const hmd = [
    {
      "title": "HMD Crest 5G",
      "landingPage": "https://cforcover.com/collections/hmd-crest-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/61RCFFatr2L._SL1000.jpg?v=1724830732"
    },
    {
      "title": "HMD Crest Max 5G",
      "landingPage": "https://cforcover.com/collections/hmd-crest-max-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/hmd-crest-max-1.jpg?v=1724830796"
    },
];
const nokia = [
{
  "title": "Nokia C30",
  "imagePath":
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nokia-c30.jpg?v=1695016322",
  "landingPage": "https://cforcover.com/collections/nokia-c30",
},
{
  "title": "Nokia G11 Plus",
  "imagePath":
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nokia_G11_Plus.jpg?v=1695016322",
  "landingPage": "https://coverpe.myshopify.com/collections/nokia-g11-plus",
},
{
  "title": "Nokia G21 4G",
  "imagePath":
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nokia-g21-dusk.jpg?v=1695016322",
  "landingPage": "https://coverpe.myshopify.com/collections/nokia-g21-4g",
},
{
  "title": "Nokia G21 5G",
  "imagePath":
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nokia-g21-dusk.jpg?v=1695016322",
  "landingPage": "https://coverpe.myshopify.com/collections/nokia-g21-5g",
},
{
   "title": "Nokia C12",
   "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nokia-c12.jpg?v=1707802500",
   "landingPage": "https://cforcover.com/collections/nokia-c12",
},
{
    "title": "Nokia T10",
    "landingPage": "https://cforcover.com/collections/nokia-t10",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_f47245bc-1512-41b7-9a01-1449586af5e3.jpg?v=1710909869"
},
{
    "title": "Nokia T20",
    "landingPage": "https://cforcover.com/collections/nokia-t20",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_bef64dee-889a-4885-88dc-52e2951b6c4e.jpg?v=1710909916"
  },
];

const motorola = [
  {
    "title": "Motorola Signature",
    "landingPage": "https://cforcover.com/collections/motorola-signature",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-signature.jpg?v=1772086951"
  },
  {
    "title": "Motorola Moto Edge 70 Fusion 5G",
    "landingPage": "https://cforcover.com/collections/motorola-moto-edge-70-fusion-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-70-fusion.jpg?v=1772086951"
  },
  {
    "title": "Motorola Moto Edge 70 5G",
    "landingPage": "https://cforcover.com/collections/motorola-moto-edge-70-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-70-5g.jpg?v=1768291536"
  },
  {
    "title": "Motorola G57 Power 5G",
    "landingPage": "https://cforcover.com/collections/motorola-g57-power-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g57-power.jpg?v=1768291536"
  },
  {
    "title": "Motorola G67 Power 5G",
    "landingPage": "https://cforcover.com/collections/motorola-g67-power-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g100-cn.jpg?v=1767939267"
  },
  {
    "title": "Motorola G06 Power 5G",
    "landingPage": "https://cforcover.com/collections/motorola-g06-power-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g06-power.jpg?v=1766208596"
  },
  {
    "title": "Motorola Moto G53 5G",
    "landingPage": "https://cforcover.com/collections/motorola-moto-g53-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g53.jpg?v=1760445790"
  },
  {
    "title": "Motorola RAZR 60 Ultra 5G",
    "landingPage": "https://cforcover.com/collections/motorola-razr-60-ultra-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-razr-60-ultra-5g.jpg?v=1757673525"
  },
    {
    "title": "Motorola G96 5G",
    "landingPage": "https://cforcover.com/collections/motorola-g96-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-g96.jpg?v=1753194512"
  },
          {
          "title": "Motorola G86 Power 5G",
          "landingPage": "https://cforcover.com/collections/motorola-g86-power-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g86-power.jpg?v=1753703522"
        },
    {
    title: "Motorola Edge 60 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-60_0da6e601-e406-49dd-b08a-86099cd139bc.jpg?v=1750233814",
    landingPage: "https://cforcover.com/collections/motorola-edge-60-5g-1"
  },
  {
    title: "Motorola Moto G15",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/mototola-moto-g15.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/motorola-moto-g15"
  },
  {
    "title": "Motorola Edge 60 Pro 5G",
    "landingPage": "https://cforcover.com/collections/motorola-edge-60-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-60-pro.jpg?v=1746695915"
  },
  {
    "title": "Motorola Edge 60 Stylus 5G",
    "landingPage": "https://cforcover.com/collections/motorola-edge-60-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-60.jpg?v=1746695915"
  },
  {
    "title": "Motorola Edge 60 Stylus 5G",
    "landingPage": "https://cforcover.com/collections/motorola-edge-60-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Edge_60_Stylus_5G.jpg?v=1747483078"
  },
  {
    "title": "Motorola G75 5G",
    "landingPage": "https://cforcover.com/collections/motorola-g75-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g75.jpg?v=1746695915"
  },
  {
    "title": "Motorola Edge 60 Fusion 5G",
    "landingPage": "https://cforcover.com/collections/motorola-edge-60-fusion-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-60-fusion.jpg?v=1745836934"
  },
  {
    "title": "Motorola G55",
    "landingPage": "https://cforcover.com/collections/motorola-g55",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_G55.jpg?v=1745056368"
  },
     {
        "title": "Motorola Moto Razr 50 Ultra 5G",
        "landingPage": "https://cforcover.com/collections/motorola-moto-razr-50-ultra-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_Razr_50_Ultra_5G.jpg?v=1740654934"
     },
     {
        "title": "Motorola Moto G45 5G",
        "landingPage": "https://cforcover.com/collections/motorola-moto-g45-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_G45.jpg?v=1739345358"
     },
     {
        "title": "Motorola Moto G05",
        "landingPage": "https://cforcover.com/collections/motorola-moto-g05",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_G05.jpg?v=1737958825"
    },
    {
        "title": "Motorola Moto G35 5G",
        "landingPage": "https://cforcover.com/collections/motorola-moto-g35-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_G35_5G.jpg?v=1737959874"
    },
     {
        "title": "Motorola Moto Edge 50 Neo 5G",
        "landingPage": "https://cforcover.com/collections/motorola-moto-edge-50-neo-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_Edge_50_Neo_5G.jpg?v=1728298772"
     },
   {
      "title": "Motorola Moto Edge 50 5G",
      "landingPage": "https://cforcover.com/collections/motorola-moto-edge-50-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_Edge_50_5G_d95b3993-887f-4b92-a9d8-cd02b53e9382.jpg?v=1724329044"
  },
   {
      "title": "Motorola Moto G85",
      "landingPage": "https://cforcover.com/collections/motorola-moto-g85",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_G85.jpg?v=1725455543"
   },
 {
      "title": "Motorola Edge 50 ultra 5G",
      "landingPage": "https://cforcover.com/collections/motorola-edge-50-ultra-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_Edge_50_Ultra_5G.jpg?v=1725342699"
  },
 {
          "title": "Motorola Edge 50 Fusion",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G50_Fusion.jpg?v=1716189118",
          "landingPage": "https://cforcover.com/collections/motorola-edge-50-fusion"
 }, 
{
      "title": "Motorola Moto One Fusion Plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-one-fusion-plus.jpg?v=1704709938",
      "landingPage": "https://cforcover.com/collections/motorola-moto-one-fusion-plus"
},
{
      "title": "Motorola Moto One Vision",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-one-vision.jpg?v=1704345206",
      "landingPage": "https://cforcover.com/collections/motorola-one-vision"
},
{
      "title": "Motorola Moto G42",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g42-r_6874b0de-786c-4c14-9dd9-75638f63b7d3.jpg?v=1704345206",
      "landingPage": "https://cforcover.com/collections/motorola-moto-g42"
},
{
  title: "Motorola G64 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Moto_G64_5G.jpg?v=1714135361",
  landingPage: "https://cforcover.com/collections/motorola-g64-5g",
},
{
  title: "Motorola Edge 30 Fusion 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge30-fusion.jpg?v=1703933025",
  landingPage: "https://cforcover.com/collections/motorola-edge-30-fusion-5g",
},
{
  title: "Motorola Moto G31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g31-baby-blue_2e6898d6-fd59-4bd1-8ab5-9e15d9d163d2.jpg?v=1704345207",
  landingPage: "https://cforcover.com/collections/motorola-g31",
},
{
  title: "Motorola G34 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g34-china.jpg?v=1707802500",
  landingPage: "https://cforcover.com/collections/motorola-g34-5g",
},
{
  title: "Motorola G30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g30_f7e7f2c3-e9ec-4e60-a6fb-06251066c491.jpg?v=1706767532",
  landingPage: "https://cforcover.com/collections/motorola-g30",
},
{
  title: "Motorola G04",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g04-4g.jpg?v=1708929131",
  landingPage: "https://cforcover.com/collections/motorola-g04",
},
{
  title: "Motorola E40",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-e40-r.jpg?v=1706266704",
  landingPage: "https://cforcover.com/collections/motorola-e40",
},
{
  title: "Motorola Edge 30 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Edge_30_Pro_5G.jpg?v=1695031466",
  landingPage:
    "https://coverpe.myshopify.com/collections/motorola-edge-30-pro-5g",
},
{
  title: "Motorola Edge 40 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-40.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/motorola-edge-40",
},
{
  title: "Motorola Edge 40 Neo 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Motorola_Edge_40_Neo_5G.jpg?v=1713524741",
  landingPage: "https://cforcover.com/collections/motorola-edge-40-neo-5g",
},
{
  title: "Motorola Edge 50 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge50-pro.jpg?v=1713430850",
  landingPage: "https://cforcover.com/collections/motorola-edge-50-pro-5g",
},
{
  title: "Motorola G40 Fusion",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G40_Fusion.jpg?v=1695031465",
  landingPage: "https://cforcover.com/collections/motorola-moto-g40-fusion",
},
{
  title: "Motorola G14",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G14.jpg?v=1695031465",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g14",
},
{
  title: "Motorola G84 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G84.jpg?v=1695031465",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g84",
},
{
  title: "Motorola G13",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g13.jpg?v=1695031467",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g13",
},
{
  title: "Motorola G22",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g22.jpg?v=1695031467",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g22",
},
{
  title: "Motorola G51 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G51_5G.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g51-5g",
},
{
  title: "Motorola G52",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g52_1.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g52",
},
{
  title: "Motorola G60",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g60.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g60",
},
{
  title: "Motorola G62 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g62.jpg?v=1695031467",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g62-5g",
},
{
  title: "Motorola G71 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Moto_G71_5G.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g71-5g",
},
{
  title: "Motorola G72",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g72.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g72",
},
{
  title: "Motorola G82 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g82.jpg?v=1695031467",
  landingPage: "https://coverpe.myshopify.com/collections/moto-g82",
},
{
  title: "Motorola Edge 20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-20.jpg?v=1695031466",
  landingPage: "https://coverpe.myshopify.com/collections/motorola-edge-20",
},
{
  title: "Motorola Moto E13",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-e13-new_e6fa0c9c-a09f-4fbd-b840-39c64928a40c.jpg?v=1699427465",
  landingPage: "https://cforcover.com/collections/motorola-moto-e13",
},
{
  title: "Motorola Moto G32",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g32_5a7e1dff-23e2-48cc-899d-70f4fda9d804.jpg?v=1702367254",
  landingPage: "https://cforcover.com/collections/motorola-moto-g32",
},
{
  title: "Motorola Moto E7 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-e7-plus_65945328-58b0-4b10-80b0-9745a11cab6c.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/motorola-moto-e7-plus",
},
{
  title: "Motorola Moto E32s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-e32_05004b50-3a36-4cff-b815-ddb23a0bde23.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/motorola-moto-e32s",
},
{
  title: "Motorola Moto Edge 30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-edge-30_b8345f05-dc3e-460b-9b35-7f2f235f34bf.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/motorola-edge-30",
},
{
  title: "Motorola G54 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/motorola-moto-g54.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/motorola-g54-5g",
},
];

const tecno = [
  {
    "title": "Tecno Pova Curve 2 5G",
    "landingPage": "https://cforcover.com/collections/tecno-pova-curve-2-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-pova-curve2.jpg?v=1774258777"
  },
   {
    "title": "Tecno Spark GO 1",
    "landingPage": "https://cforcover.com/collections/tecno-spark-go-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go1.jpg?v=1755339319"
  },
  {
    "title": "Tecno Spark Go 2",
    "landingPage": "https://cforcover.com/collections/tecno-spark-go-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go2.jpg?v=1755339319"
  },
{
  title: "Tecno Pop 6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-pop6-pro.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-pop-6-pro",
},
{
  title: "Tecno Spark 7 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Tecno_Spark_7_Pro.jpg?v=1713524857",
  landingPage: "https://cforcover.com/collections/tecno-spark-7-pro",
},
{
  title: "Tecno Spark 10 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark10-pro.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-10-pro",
},
{
  title: "Tecno Spark 6 Air",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Tecno_Spark_6_Air.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-6-air",
},
{
  title: "Tecno Spark 6 Go",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-6-go.jpg?v=1695198896",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-6-go",
},
{
  title: "Tecno Spark 7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-7.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-7",
},
{
  title: "Tecno Spark 7T",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-7t.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-7t",
},
{
  title: "Tecno Spark 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-8.jpg?v=1695198894",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-8",
},
{
  title: "Tecno Spark 8C",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-8c.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-8c",
},
{
  title: "Tecno Spark 9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Tecno_Spark_9.jpg?v=1695198895",
  landingPage: "https://coverpe.myshopify.com/collections/tecno-spark-9",
},
{
  title: "Tecno Spark Go 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go-2020.jpg?v=1695198896",
  landingPage:
    "https://coverpe.myshopify.com/collections/tecno-spark-go-2020",
},
{
  title: "Tecno Spark Go 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Tecno_Spark_Go_2021.jpg?v=1695198895",
  landingPage:
    "https://coverpe.myshopify.com/collections/tecno-spark-go-2021",
},
{
  title: "Tecno Spark Go 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go-2022.jpg?v=1695198895",
  landingPage:
    "https://coverpe.myshopify.com/collections/tecno-spark-go-2022",
},
{
  title: "Tecno Spark Go 2023",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go-2023.jpg?v=1695198895",
  landingPage:
    "https://coverpe.myshopify.com/collections/tecno-spark-go-2023",
},
{
  title: "Tecno Spark Go 2024",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/tecno-spark-go-2024.jpg?v=1702981506",
  landingPage: "https://cforcover.com/collections/tecno-spark-go-2024",
},
];

const vivo = [
  {
    "title": "Vivo V70 FE 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v70-fe-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v70-fe.jpg?v=1776510893"
  },
  {
    "title": "Vivo T5x 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t5x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t5x-5g.jpg?v=1774424250"
  },
  {
    "title": "Vivo Y51 Pro 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y51-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y51-pro.jpg?v=1774424250"
  },
  {
    "title": "Vivo Y11 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y11-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y11_5g.png?v=1774430321"
  },
  {
    "title": "Vivo Y21 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y21-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y21_5g.png?v=1774430321"
  },
  {
    "title": "Vivo X300 FE 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x300-fe-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-s50-pro-mini.jpg?v=1772196465"
  },
  {
    "title": "Vivo V21e 4G",
    "landingPage": "https://cforcover.com/collections/vivo-v21e-4g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v21e_12cc97ef-14d5-4f7e-af55-b917c66f1f82.jpg?v=1771937926"
  },
  {
    "title": "Vivo X200T 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x200t-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x200-t.jpg?v=1772086951"
  },
  {
    "title": "Vivo V70 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v70-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v70.jpg?v=1772086951"
  },
  {
    "title": "Vivo V70 Elite 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v70-elite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v70-elite.jpg?v=1772086951"
  },
  {
    "title": "Vivo V60e 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v60e-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v60e.jpg?v=1768038251"
  },
  {
    "title": "Vivo Y500 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y500-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y500-cn.jpg?v=1766208596"
  },
  {
    "title": "Vivo X300 Pro 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x300-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x300-pro.jpg?v=1766124245"
  },
  {
    "title": "Vivo X300 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x300-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x300.jpg?v=1766124244"
  },
   {
    "title": "Vivo Y31 2025",
    "landingPage": "https://cforcover.com/collections/vivo-y31-2025",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y31-5g.jpg?v=1763791521"
  },
  {
    "title": "Vivo Y31 Pro 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y31-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y31-pro.jpg?v=1764307461"
  },
  {
    "title": "Vivo Y19 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y19-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y19-5g.jpg?v=1761299460"
  },
  {
    "title": "Vivo Y200i 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y200i-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y200i.jpg?v=1761895438"
  },
  {
    "title": "Vivo Y20G",
    "landingPage": "https://cforcover.com/collections/vivo-y20g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y20g_d5d85fa5-4c80-4fb5-ae03-cd18c2181e20.jpg?v=1761895437"
  },
  {
    "title": "Vivo X Fold 5",
    "landingPage": "https://cforcover.com/collections/vivo-x-fold-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x-fold5-new.jpg?v=1760445799"
  },
  {
    "title": "Vivo Y400 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y400-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y400-5g.jpg?v=1758265990"
  },
   {
    "title": "Vivo V60 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v60-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v60.jpg?v=1756381190"
  },
  {
    "title": "Vivo T4 Pro 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t4-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t4-pro.jpg?v=1756381190"
  },
  {
    "title": "Vivo T4 Lite 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t4-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t4-lite.jpg?v=1755339319"
  },
    {
    "title": "Vivo V50e 5G",
    "landingPage": "https://cforcover.com/collections/vivo-v50e-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v50e.jpg?v=1753194512"
  },
  {
    "title": "Vivo Y400 Pro 5G",
    "landingPage": "https://cforcover.com/collections/vivo-y400-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y400-pro.jpg?v=1753194512"
  },
  {
    "title": "Vivo X200 FE 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x200-fe-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x200-fe.jpg?v=1753703522"
  },
  {
    "title": "Vivo T4R 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t4r-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z10r.jpg?v=1753703522"
  },
  {
    title: "Vivo T4 Ultra 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t-4-ultra.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/vivo-t4-ultra-5g"
  },
  {
    "title": "Vivo T4 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t4-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t4.jpg?v=1746695915"
  },
  {
    "title": "Vivo T4x 5G",
    "landingPage": "https://cforcover.com/collections/vivo-t4x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T4x_5G_3faa51a1-9274-4279-b3d0-6115d064dda6.jpg?v=1747483077"
  },
  {
    "title": "Vivo V20",
    "landingPage": "https://cforcover.com/collections/vivo-v20",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v20-new_6ed11d59-25c0-4ad7-806a-88d568cdb83a.jpg?v=1746695915"
  },
  {
    "title": "Vivo X70 Pro Plus 5G",
    "landingPage": "https://cforcover.com/collections/vivo-x70-pro-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X70_Pro_Plus_5G.jpg?v=1747483078"
  },
      {
        "title": "Vivo Y19e 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y19e-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y04.jpg?v=1742638303"
      },
      {
        "title": "Vivo Y39 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y39-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y39_5G.png?v=1742638616"
      },
      {
        "title": "Vivo V50 5G",
        "landingPage": "https://cforcover.com/collections/vivo-v50-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V50_5G.jpg?v=1742357280"
      },
      {
        "title": "Vivo T4x 5G",
        "landingPage": "https://cforcover.com/collections/vivo-t4x-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T4x_5G.jpg?v=1742357295"
      },
      {
        "title": "Vivo Y300 Pro 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y300-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y300_Pro_5G.jpg?v=1739437248"
      },
      {
        "title": "Vivo Y29 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y29-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y29_5G.jpg?v=1737958817"
     },
     {
        "title": "VIvo X200 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x200-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X200_5G.jpg?v=1735275307"
    },
    {
        "title": "VIvo X200 Pro 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x200-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X200_Pro_5G.jpg?v=1735275307"
    },
    {
        "title": "Vivo Y300 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y300-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y300_5G.jpg?v=1734440624"
    },
     {
        "title": "Vivo X80 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x80-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x80.jpg?v=1694411000"
    },
    {
        "title": "Vivo Y300 Plus 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y300-plus-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y300_Plus_5G.jpg?v=1730288783"
    },  
    {
        "title": "Vivo V40e 5G",
        "landingPage": "https://cforcover.com/collections/vivo-v40e-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V40e_5G.jpg?v=1728734341"
    },
    {
        "title": "Vivo Y58 5G",
        "landingPage": "https://cforcover.com/collections/vivo-y58-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y58_5G.jpg?v=1728734446"
    },
    {
        "title": "Vivo T3 lite 5G",
        "landingPage": "https://cforcover.com/collections/vivo-t3-lite-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T3_lite_5G_d9439d9e-0bf2-486d-bcad-77fe70177aa5.jpg?v=1728298773"
    },
    {
        "title": "Vivo X100 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x100",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X100_5G.jpg?v=1728298772"
    },
    {
        "title": "Vivo X100 Pro 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x100-pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X100_Pro_5G.jpg?v=1728298772"
    },
    {
        "title": "Vivo X50 Pro 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x50-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X50_Pro_5G_3ab0a138-f9f8-4a71-8355-2d618ee0ab6c.jpg?v=1728298772"
    },
    {
        "title": "Vivo X70 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x70",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X70_Pro_5G.jpg?v=1728298772"
    },
    {
        "title": "Vivo X70 Pro 5G",
        "landingPage": "https://cforcover.com/collections/vivo-x70-pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X70_Pro_5G.jpg?v=1728298772"
    },
    
    {
      "title": "Vivo T3 Ultra 5G",
      "landingPage": "https://cforcover.com/collections/vivo-t3-ultra-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T3_Ultra_5G.jpg?v=1727765218"
    },
    {
      "title": "Vivo T3x 5G",
      "landingPage": "https://cforcover.com/collections/vivo-t3x-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T3x_5G_8e337a88-4152-46fa-bcad-54e60f35ea3d.jpg?v=1727765217"
    },
   {
      "title": "Vivo V40 5G",
      "landingPage": "https://cforcover.com/collections/vivo-v40-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V40_5G_8737d3a3-241d-40aa-854e-ff547418d43f.jpg?v=1727765217"
  },
  {
      "title": "Vivo V40 Pro 5G",
      "landingPage": "https://cforcover.com/collections/vivo-v40-pro-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V40_Pro_5G_558bbdef-318c-43a0-9e81-c52be87e8f77.jpg?v=1727765217"
  },
  {
      "title": "Vivo Y17s",
      "landingPage": "https://cforcover.com/collections/vivo-y17s",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y17s_66586fef-2a4f-4704-b76a-ab8d553cbfe2.jpg?v=1727768476"
  },
  {
      "title": "Vivo Y200A 5G",
      "landingPage": "https://cforcover.com/collections/vivo-y200a-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1-c1-vivo-y200a-qj0yktsy.webp?v=1727774116"
  },
       {
         "title": "Vivo V40 Lite 5G",
         "landingPage": "https://cforcover.com/collections/vivo-v40-lite-5g",
         "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V40_Lite_5G.jpg?v=1725454870"
       },
       {
          "title": "Vivo T3 Pro 5G",
          "landingPage": "https://cforcover.com/collections/vivo-t3-pro-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T3_Pro_5G.jpg?v=1725454882"
       },
      {
        "title": "Vivo X60",
        "landingPage": "https://cforcover.com/collections/vivo-x60",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x60.jpg?v=1694410999"
      },
      {
        "title": "Vivo X60 Pro",
        "landingPage": "https://cforcover.com/collections/vivo-x60-pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X60_Pro.jpg?v=1713430733"
      },
      {
        "title": "Vivo Y28e 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y28e_5G.jpg?v=1722237665",
        "landingPage": "https://cforcover.com/collections/vivo-y28e-5g"
      },
      {
        "title": "Vivo Y28s 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y28S_5G.jpg?v=1722237665",
        "landingPage": "https://cforcover.com/collections/vivo-y28s-5g"
      }, 
     {
       "title": "Vivo Y200 Pro 5G",
       "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y200_Pro.jpg?v=1717075490",
       "landingPage": "https://cforcover.com/collections/vivo-y200-pro-5g"
     },
     {
       "title": "Vivo V20 SE",
       "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V20_SE.jpg?v=1715860488",
       "landingPage": "https://cforcover.com/collections/vivo-v20-se"
     },
    {
      "title": "Vivo Y18",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y18.jpg?v=1715832856",
      "landingPage": "https://cforcover.com/collections/vivo-y18"
    },
    {
      "title": "Vivo Y18e",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y18_e.jpg?v=1715832857",
      "landingPage": "https://cforcover.com/collections/vivo-y18e"
    },
   {
      "title": "Vivo V30e 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V30e_5G.jpg?v=1715259206",
      "landingPage": "https://cforcover.com/collections/vivo-v30e-5g"
   },

   {
      "title": "Vivo T3x 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T3x_5G.jpg?v=1714135530",
      "landingPage": "https://cforcover.com/collections/vivo-t3x-5g"
  },
{
  title: "Vivo Y28 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y28-5g.jpg?v=1713430922",
  landingPage: "https://cforcover.com/collections/vivo-y28-5g",
},
{
  title: "Vivo Y200e 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y200e-5g.jpg?v=1708929131",
  landingPage: "https://cforcover.com/collections/vivo-y200e-5g",
},
{
  title: "Vivo X100",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x100.jpg?v=1707802500",
  landingPage: "https://cforcover.com/collections/vivo-x100",
},
{
  title: "Vivo V5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v5.jpg?v=1687418423",
  landingPage: "https://cforcover.com/collections/vivo-v5",
},
{
  title: "Vivo V30 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-s18.jpg?v=1708929131",
  landingPage: "https://cforcover.com/collections/vivo-v30-5g",
},
{
  title: "Vivo T3 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_bd9cb8fb-0fae-4ac0-bde2-9ff8d1df993d.jpg?v=1712216934",
  landingPage: "https://cforcover.com/collections/vivo-t3-5g",
},
{
  title: "Vivo V30 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_d36dd312-1475-4444-8855-62cbe1adb518.jpg?v=1712217029",
  landingPage: "https://cforcover.com/collections/vivo-v30-pro-5g",
},
{
  title: "Vivo S1",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-s1-v1907_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-s1",
},
{
  title: "Vivo S1 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_S1_Pro.jpg?v=1713430876",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-s1-pro",
},
{
  title: "Vivo S10E",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-s10e.jpg?v=1699431576",
  landingPage: "https://cforcover.com/collections/vivo-s10e",
},
{
  title: "Vivo T1 44W",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t1-sndrgn680_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-t1-44w",
},
{
  title: "Vivo T1x 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T1x_4G.jpg?v=1713430686",
  landingPage: "https://cforcover.com/collections/vivo-t1x-4g",
},
{
  title: "Vivo T1 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t1-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-t1-5g",
},
{
  title: "Vivo T1 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t1-5g-778g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-t1-pro-5g",
},
{
  title: "Vivo T2 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_T2_5G.jpg?v=1714125731",
  landingPage: "https://cforcover.com/collections/vivo-t2-5g",
},
{
  title: "Vivo T2x 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t2x-india_4a5aec73-2cd3-4eb9-8d99-3eaf06cdb4db.jpg?v=1687429452",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-t2x-5g",
},
{
  title: "Vivo U10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-u10.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-u10",
},
{
  title: "Vivo U20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-u20.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-u20",
},
{
  title: "Vivo V15",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v15.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v15",
},
{
  title: "Vivo V15 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v15-pro.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v15-pro",
},
{
  title: "Vivo V17",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v17-india.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v17",
},
{
  title: "Vivo V20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V20.jpg?v=1713430705",
  landingPage: "https://cforcover.com/collections/vivo-v20",
},
{
  title: "Vivo V20 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v20-pro.jpg?v=1694410999",
  landingPage: "https://cforcover.com/collections/vivo-v20-pro-5g",
},
{
  title: "Vivo V21 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v21-5g_60x60.jpg?v=1687418423",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v21-5g",
},
{
  title: "Vivo V21e 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v21e-5g.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v21e-5g",
},

{
  title: "Vivo V23 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v23-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v23-5g",
},
{
  title: "Vivo V23 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v23-pro_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v23-pro-5g",
},
{
  title: "Vivo V23e 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v23e_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v23e-5g",
},
{
  title: "Vivo V25",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v25.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v25",
},
{
  title: "Vivo V25 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v25_df315084-4177-4978-8df1-d36c50cabb04.jpg?v=1687428672",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v25-5g",
},
{
  title: "Vivo V25 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_V25_5G.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v25-pro-5g",
},
{
  title: "Vivo V25e 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v25e_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v25e-5g",
},

{
  title: "Vivo V27 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v27_88154493-5bdc-4d2f-9446-987de8616065.jpg?v=1687429582",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v27-5g",
},
{
  title: "Vivo V27 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v27-pro_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v27-pro",
},
{
  title: "Vivo V29 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v29-5g.jpg?v=1699431403",
  landingPage: "https://cforcover.com/collections/vivo-v29-5g",
},
{
  title: "Vivo V29 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v29-pro-gg.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-v29-pro-5g",
},
{
  title: "Vivo V29e 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v29-e-5g.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-v29e-5g",
},
{
  title: "Vivo V9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v9.jpg?v=1687418423",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-v9",
},
{
  title: "Vivo V9 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v9_c767182d-59c2-4855-b395-aea98b31cd4a.jpg?v=1699431328",
  landingPage: "https://cforcover.com/collections/vivo-v9-pro",
},
{
  title: "Vivo V9 youth",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v9-youth.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-v9-youth",
},
{
  title: "Vivo X60 pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X60_Pro.jpg?v=1713430733",
  landingPage: "https://cforcover.com/collections/vivo-x60-pro",
},
{
  title: "Vivo X70 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_X70_Pro.jpg?v=1713430766",
  landingPage: "https://cforcover.com/collections/vivo-x70-pro",
},
{
  title: "Vivo Y02",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/viv0-y02_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y02",
},
{
  title: "Vivo Y02s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y02s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y02s",
},
{
  title: "Vivo Y02T",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y02t.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y02t",
},
{
  title: "Vivo Y100",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y100.jpg?v=1694410999",
  landingPage:
    "https://coverpe.myshopify.com/collections/vivo-y100",
},
{
  title: "Vivo Y100A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y100A.png?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y100a",
},
{
  title: "Vivo Y11s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y11s.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-y11s",
},
{
  title: "Vivo Y12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y12_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y12",
},
{
  title: "Vivo Y12G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y12G.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y12g",
},
{
  title: "Vivo Y12s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y12s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y12s",
},
{
  title: "Vivo Y15 2019",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y15.jpg?v=1713430794",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y15-2019",
},
{
  title: "Vivo Y15A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y15a.jpg?v=1699429583",
  landingPage: "https://cforcover.com/collections/vivo-y15a",
},
{
  title: "Vivo Y15c",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y15c.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y15c",
},
{
  title: "Vivo Y15S ",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y15s-new_60x60.jpg?v=1687418424",
  landingPage: "https://cforcover.com/collections/vivo-y15s",
},
{
  title: "Vivo Y15s 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y15s-new_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y15s-2022",
},
{
  title: "Vivo Y16",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y16_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y16",
},
{
  title: "Vivo Y17",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y17.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y17",
},
{
  title: "Vivo Y19",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y19_4e51cf8e-6134-437c-bad4-3327bb820e29.jpg?v=1694610652",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y19",
},
{
  title: "Vivo Y1s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y1s.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y1s",
},
{
  title: "Vivo Y20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y20.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y20",
},
{
  title: "Vivo Y20 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y20.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y20-2021",
},
{
  title: "Vivo Y20A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y20-2021_9f04514a-e4c1-4b40-8c1f-7f35cd9e24ce.jpg?v=1699431248",
  landingPage: "https://cforcover.com/collections/vivo-y20a",
},
{
  title: "Vivo Y20i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y20.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y20i",
},
{
  title: "Vivo Y21 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y21_2021.jpg?v=1713430894",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y21-2021",
},
{
  title: "Vivo Y21A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y21-_1.jpg?v=1687428862",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y21a",
},
{
  title: "Vivo Y21e",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y21-_2.jpg?v=1687428974",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y21e",
},
{
  title: "Vivo Y21S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y21s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y21s",
},
{
  title: "Vivo Y21T",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y21s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y21t",
},
{
  title: "Vivo Y22",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y22-2022_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y22",
},
{
  title: "Vivo Y22s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y22s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y22s",
},
{
  title: "Vivo Y27 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y27_4G.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y27-4g",
},
{
  title: "Vivo Y30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y30_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y30",
},
{
  title: "Vivo Y30G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y30_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y30g",
},
{
  title: "Vivo Y31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y31-2021.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y31",
},
{
  title: "Vivo Y31 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y31-2021.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y31-2021",
},
{
  title: "Vivo Y32",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y32_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y32",
},
{
  title: "Vivo Y33S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y33s_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y33s",
},
{
  title: "Vivo Y33T",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y33t_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y33t",
},
{
  title: "Vivo Y35",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y35-2022_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y35",
},
{
  title: "Vivo Y36",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y36-5g.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y36",
},
{
  title: "Vivo Y50",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y50.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y50",
},
{
  title: "Vivo Y51 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y51_2020.jpg?v=1713430829",
  landingPage: "https://cforcover.com/collections/vivo-y51-2020",
},
{
  title: "Vivo Y51A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y50.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y51a",
},
{
  title: "Vivo Y53s 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y53s-4g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y53s-4g",
},
{
  title: "Vivo Y53s 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y53s_25ea491c-c10d-4379-9391-c073f9a445a2.jpg?v=1698834524",
  landingPage: "https://cforcover.com/collections/vivo-y53s-5g",
},
{
  title: "Vivo Y55 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y55-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y55-5g",
},
{
  title: "Vivo Y56 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y56-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y56-5g",
},
{
  title: "Vivo Y17s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y17s.jpg?v=1713430811",
  landingPage: "https://cforcover.com/collections/vivo-y17s",
},
{
  title: "Vivo Y71",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y71.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y71",
},
{
  title: "Vivo Y73 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v21e_60x60.jpg?v=1687418423",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y73-2022",
},
{
  title: "Vivo Y75 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y75.jpg?v=1694410999",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y75-4g",
},
{
  title: "Vivo Y75 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y55-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y75-5g",
},
{
  title: "Vivo Y83 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y83-pro.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y83-pro",
},
{
  title: "Vivo Y89",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y89.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-y89",
},
{
  title: "Vivo Y90",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y90_dd6d1eb3-92bd-4e90-af60-8c742da971a8.jpg?v=1694611205",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y90",
},
{
  title: "Vivo Y91",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y91.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y91",
},
{
  title: "Vivo Y91i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y91i.jpg?v=1713430942",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y91i",
},
{
  title: "Vivo Y93",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Vivo_Y93.jpg?v=1713430963",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y93",
},
{
  title: "Vivo Y95",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y95_09b91d07-5073-4c21-b42b-dbac0469f457.jpg?v=1687429280",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-y95",
},
{
  title: "Vivo Z1x",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-z1x.jpg?v=1694411000",
  landingPage: "https://coverpe.myshopify.com/collections/vivo-z1x",
},
{
  title: "Vivo Z5x",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-z5x.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/vivo-z5x",
},
{
  title: "Vivo Y200",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-y200_713ff9c9-7de3-4709-ba75-0db70cca234e.jpg?v=1702367599",
  landingPage: "https://cforcover.com/collections/vivo-y200-5g",
},
{
  title: "Vivo X90 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x90-pro_e81334ee-5771-4b91-993b-2feabcd081fc.jpg?v=1702624482",
  landingPage: "https://cforcover.com/collections/vivo-x90-pro-5g",
},
{
  title: "Vivo X90 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-x90_45a5d76e-389b-4684-b5eb-74573c5cde6f.jpg?v=1702624481",
  landingPage: "https://cforcover.com/collections/vivo-x90-5g",
},
{
  title: "Vivo T2 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-t2-pro.jpg?v=1702981506",
  landingPage: "https://cforcover.com/collections/vivo-t2-pro-5g",
},
{
  title: "Vivo V17 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-v17-pro-r.jpg?v=1694410999",
  landingPage: "https://cforcover.com/collections/vivo-v17-pro",
},
];

const itel = [
   {
      "title": "Itel Vision 2",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel_Vision_2.jpg?v=1715860488",
      "landingPage": "https://cforcover.com/collections/itel-vision-2"
  },
  {
      "title": "Itel Vision 1 Pro",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel_Vision_1_Pro.jpg?v=1715860488",
      "landingPage": "https://cforcover.com/collections/itel-vision-1-pro"
  },
{
  title: "Itel A70",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a70.jpg?v=1706266704",
  landingPage: "https://cforcover.com/collections/itel-a70",
},
{
  title: "itel A48",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a48.jpg?v=1695361491",
  landingPage: "https://cforcover.com/collections/itel-a48",
},
{
  title: "Itel A05s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a05s.jpg?v=1708151527",
  landingPage: "https://cforcover.com/collections/itel-a05s",
},
{
  title: "Itel A23",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a23.jpg?v=1699427319",
  landingPage: "https://coverpe.myshopify.com/collections/itel-a23",
},
{
  title: "Itel A23 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a23-pro.jpg?v=1695361490",
  landingPage: "https://coverpe.myshopify.com/collections/itel-a23-pro",
},
{
  title: "Itel A27",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-a27.jpg?v=1695361491",
  landingPage: "https://coverpe.myshopify.com/collections/itel-a27",
},
{
  title: "Itel S23 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/itel-s23_89f77ab9-65d6-4284-954d-c026a4b6273c.jpg?v=1699427377",
  landingPage: "https://coverpe.myshopify.com/collections/itel-s23-4g",
},
];

const onePlus = [
  {
    "title": "OnePlus Nord 6 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-6-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-turbo-6.jpg?v=1777009677"
  },
  {
    "title": "OnePlus Nord CE 6 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-ce-6-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce6.jpg?v=1777009677"
  },
  {
    "title": "OnePlus Nord CE 6 Lite 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-ce-6-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce6-lite.jpg?v=1777009677"
  },
  {
    "title": "Oneplus 15 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-15.jpg?v=1766124864"
  },
  {
    "title": "Oneplus 15R 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-15r-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-15r.jpg?v=1766124864"
  },
    {
    "title": "OnePlus Nord 5 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-5-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord5.jpg?v=1753194512"
  },
  {
    "title": "OnePlus Nord CE 5 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-ce-5-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce5.jpg?v=1753194512"
  },
    {
    title: "OnePlus 13S 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_13S_5G.jpg?v=1748954447",
    landingPage: "https://cforcover.com/collections/oneplus-13s-5g"
  },
  {
    "title": "OnePlus 13T 5G",
    "landingPage": "https://cforcover.com/collections/oneplus-13t-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_13T_5G.jpg?v=1747483077"
  },
  {
    "title": "OnePlus 5T",
    "landingPage": "https://cforcover.com/collections/oneplus-5t",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_5T.jpg?v=1727765217"
  },
     {
        "title": "OnePlus 13 5g",
        "landingPage": "https://cforcover.com/collections/oneplus-13-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_13_5G.jpg?v=1735369239"
    },
     {
        "title": "OnePlus 7 Pro",
        "landingPage": "https://cforcover.com/collections/oneplus-7-pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_7_Pro_35428079-01f5-42e4-a4be-b53d2239e645.jpg?v=1728298772"
    },
    {
        "title": "OnePlus 13R 5G",
        "landingPage": "https://cforcover.com/collections/oneplus-13r-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-13r.jpg?v=1737526156"
    },
    {
        "title": "OnePlus Nord 4 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_4.jpg?v=1722338678",
        "landingPage": "https://cforcover.com/collections/oneplus-nord-4-5g"
    },
    {
        "title": "OnePlus Nord CE 4 Lite 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_CE_4_Lite.jpg?v=1719321968",
        "landingPage": "https://cforcover.com/collections/oneplus-nord-ce-4-lite-5g"
    },
     {
        "title": "OnePlus Nord CE 4 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/7566ea60849d2f630ee1e1ff07e3620e67701c99.webp?v=1712405998",
        "landingPage": "https://cforcover.com/collections/oneplus-nord-ce-4-5g"
    },   
    {
        "title": "OnePlus 12R 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-12r-new.jpg?v=1708929131",
        "landingPage": "https://cforcover.com/collections/oneplus-12r-5g"
    }, 
    {
        "title": "OnePlus 12 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-12.jpg?v=1706266704",
        "landingPage": "https://cforcover.com/collections/oneplus-12-5g"
    },  
    {
        "title": "OnePlus Nord CE 3 Lite 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce-3-lite_62248d00-0762-4563-aa08-a84a4b633a7e.jpg?v=1687426143",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-ce-3-lite-5g",
    },
    {
        "title": "OnePlus Nord CE 3 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_CE_3_5G_1.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-ce-3-5g",
    },
    {
        "title": "OnePlus Nord CE 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce-5g_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-ce-5g",
    },
    {
        "title": "OnePlus Nord 3 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_CE_3_5G.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-3-5g",
    },
    {
        "title": "OnePlus 11 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-ace2_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-11-5g",
    },
    {
        "title": "OnePlus 11R 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-ace2_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-11r-5g",
    },
    {
        "title": "OnePlus Nord CE 2 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce-2-5g_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-ce-2-5g",
    },
    {
        "title": "OnePlus Nord CE 2 Lite 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-ce-2-lite-5g-0_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-ce-2-lite-5g",
    },
    {
        "title": "OnePlus Nord 2 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-2-5g-new_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-2-5g",
    },
    {
        "title": "OnePlus Nord 2T 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-nord-2t_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-2t-5g",
    },
    {
        "title": "OnePlus 10R 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-10r_60x60.jpg?v=1687418412",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-10r-5g",
    },
    {
        "title": "OnePlus 10T 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-10t-5g_e4d7e973-b669-4d74-bc32-b7603e7b6417.jpg?v=1698834500",
        "landingPage": "https://cforcover.com/collections/oneplus-10t-5g",
    },
    {
        "title": "OnePlus 6",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_6T.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-6",
    },
    {
        "title": "OnePlus 6T",
        "imagePath":  "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_6T.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-6t",
    },
    {
        "title": "OnePlus 7",
        "imagePath":"https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_7.png?v=1694421273",
        "landingPage":"https://coverpe.myshopify.com/collections/oneplus-7",
    },
    {
      "title": "OnePlus 7T",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_7T.png?v=1694421273",
      "landingPage": "https://coverpe.myshopify.com/collections/oneplus-7t",
    },
    {
        "title": "OnePlus 8",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-8.jpg?v=1694410786",
        "landingPage": "https://cforcover.com/collections/oneplus-8",
    },
    {
        "title": "OnePlus 8 Pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-8-pro.jpg?v=1703932741",
        "landingPage": "https://cforcover.com/collections/oneplus-8-pro",
    },
    {
        "title": "OnePlus 8T",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_8T-1.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-8t",
    },
    {
        "title": "OnePlus 9",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_9.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-9",
    },
    {
        "title": "OnePlus 9R",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oneplus_9R.jpg?v=1713430017",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-9r",
    },
    {
        "title": "OnePlus 9RT",
         "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-9-rt-r_60x60.jpg?v=1687418411",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-9rt",
    },
    {
        "title": "Oneplus Nord",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oneplus_Nord.jpg?v=1713430122",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord",
    },
    {
        "title": "OnePlus 10 Pro 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-10-pro_3bdca6dd-09b1-4c5a-8fff-ec6ad5af0d13.jpg?v=1708151527",
        "landingPage": "https://cforcover.com/collections/oneplus-10-pro-5g",
    },
    {
        "title": "OnePlus 5",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-5.jpg?v=1708151527",
        "landingPage": "https://cforcover.com/collections/oneplus-5"
    },
    {
        "title": "OnePlus 7T Pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-7t-pro.jpg?v=1708151527",
        "landingPage": "https://cforcover.com/collections/oneplus-7t-pro"
    },
    {
        "title": "OnePlus 9 Pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_9_Pro.png?v=1694421274",
        "landingPage": "https://cforcover.com/collections/oneplus-9-pro"
    },
    {
        "title": "OnePlus Ace 2 Pro",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-ace2.jpg?v=1687418411",
        "landingPage": "https://cforcover.com/collections/oneplus-ace-2-pro"
    },
    {
        "title": "OnePlus Nord N20 SE",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_N20_SE.png?v=1694421274",
        "landingPage": "https://coverpe.myshopify.com/collections/oneplus-nord-n20-se",
    },
     
    {
        "title": "OnePlus Open",
        "imagepath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-open-10_afb82824-e0af-40f4-a409-dbcdb7545330.jpg?v=1739969476",
        "landingPage": "https://cforcover.com/collections/oneplus-open",
    },
    {
        "title": "OnePlus Pad 11.61",
        "landingPage": "https://cforcover.com/collections/oneplus-pad-11-61",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_36b39222-0ee5-4e2c-b35a-7eb7e5da11ad.jpg?v=1710910013"
    },
    
];

const google = [
  {
    "title": "Google Pixel 10A 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-10a-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-10a.jpg?v=1776861743"
  },
  {
    "title": "Google Pixel 10 Pro 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-10-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-10-pro.jpg?v=1756381190"
  },
  {
    "title": "Google Pixel 10 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-10-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-9.jpg?v=1753194512"
  },
  {
    "title": "Google Pixel 10 Pro XL 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-10-pro-xl-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-9-pro-xl_3fa79438-282a-4cec-b0b0-1e2ff684d10f.jpg?v=1753194512"
  },
  {
    "title": "Google Pixel 9 Pro 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-9-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_9_Pro_5G_ccd1a347-914f-4fb1-9231-8d864fde0988.jpg?v=1745056361"
  },
  {
    "title": "Google Pixel 9A 5G",
    "landingPage": "https://cforcover.com/collections/google-pixel-9a-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-9a.jpg?v=1742638510"
  },
  {
    "title": "Google Pixel 9 Pro XL",
    "landingPage": "https://cforcover.com/collections/google-pixel-9-pro-xl",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-9-pro-xl.jpg?v=1742637410"
  },
  {
      "title": "Google Pixel 9",
      "landingPage": "https://cforcover.com/collections/google-pixel-9-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_9_5G.jpg?v=1727765217"
  },
  {
      "title": "Google Pixel 9 Pro XL",
      "landingPage": "https://cforcover.com/collections/google-pixel-9-pro-xl",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_9_Pro_5G.jpg?v=1727765217"
  },
{
  title: "Google Pixel 8A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Pixel_8A.jpg?v=1716016065",
  landingPage: "https://cforcover.com/collections/google-pixel-8a",
},
{
  title: "Google Pixel 7 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_7_5G.png?v=1694422367",
  landingPage: "https://coverpe.myshopify.com/collections/google-pixel-7-5g",
},
{
  title: "Google Pixel 7 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_7_Pro_5G.png?v=1694422367",
  landingPage:
    "https://coverpe.myshopify.com/collections/google-pixel-7-pro-5g",
},
{
  title: "Google Pixel 7A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_7A.png?v=1694422367",
  landingPage: "https://coverpe.myshopify.com/collections/google-pixel-7a",
},
{
  title: "Google Pixel 4A 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixe_4A.png?v=1694422367",
  landingPage: "https://coverpe.myshopify.com/collections/google-pixel-4",
},
{
  title: "Google Pixel 4A 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-4a-5g.jpg?v=1699426848",
  landingPage: "https://cforcover.com/collections/google-pixel-4-5g",
},
{
  title: "Google Pixel 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_6.png?v=1694422367",
  landingPage: "https://coverpe.myshopify.com/collections/google-pixel-6",
},
{
  title: "Google Pixel 6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_6_Pro.png?v=1694422367",
  landingPage: "https://cforcover.com/collections/google-pixel-6-pro",
},
{
  title: "Google Pixel 6A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_6A.png?v=1694422367",
  landingPage: "https://coverpe.myshopify.com/collections/google-pixel-6a",
},
{
  title: "Google Pixel 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-8.jpg?v=1702368455",
  landingPage: "https://cforcover.com/collections/google-pixel-8",
},
{
  title: "Google Pixel 8 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/google-pixel-8-pro.jpg?v=1702368455",
  landingPage: "https://cforcover.com/collections/google-pixel-8-pro",
},
{
  title: "Google Pixel 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Google_Pixel_5.png?v=1694422367",
  landingPage: "https://cforcover.com/collections/google-pixel-5",
},
];

const poco = [
  {
    "title": "Poco C85X 5G",
    "landingPage": "https://cforcover.com/collections/poco-c85x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-c85x.jpg?v=1776510893"
  },
  {
    "title": "Poco C85 5G",
    "landingPage": "https://cforcover.com/collections/poco-c85-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-c85-5g.jpg?v=1772171626"
  },
  {
    "title": "Poco M7 Plus 5G",
    "landingPage": "https://cforcover.com/collections/poco-m7-plus-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-m7-plus.jpg?v=1764307459"
  },
   {
    "title": "Poco F7 5G",
    "landingPage": "https://cforcover.com/collections/poco-f7-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-f7-new.jpg?v=1755339319"
  },
  {
    "title": "Poco C71",
    "landingPage": "https://cforcover.com/collections/poco-c71",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-c71.jpg?v=1746695915"
  },
  {
    "title": "Poco F7 Pro 5G",
    "landingPage": "https://cforcover.com/collections/poco-f7-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-f7-pro.jpg?v=1746695915"
  },
  {
    "title": "Poco F7 Ultra 5G",
    "landingPage": "https://cforcover.com/collections/poco-f7-ultra-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-f7-ultra.jpg?v=1746696046"
  },
  {
    "title": "Poco X3 Pro 4G",
    "landingPage": "https://cforcover.com/collections/poco-x3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_X3_Pro_4G.jpg?v=1745056339"
  },
    {
      "title": "Poco M7 5G",
      "landingPage": "https://cforcover.com/collections/poco-m7-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-m7-5g.jpg?v=1742638310"
    },
    {
        "title": "Poco M6 Plus 5G",
        "landingPage": "https://cforcover.com/collections/poco-m6-plus-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_M6_Plus_5G.jpg?v=1734940652"
    },
    {
        "title": "Poco M7 Pro 5G",
        "landingPage": "https://cforcover.com/collections/poco-m7-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-m7-pro-5g.jpg?v=1737701852"
    },
    {
        "title": "Poco X7 5G",
        "landingPage": "https://cforcover.com/collections/poco-x7-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_X7_5G.jpg?v=1737958810"
    },
    {
        "title": "Poco X7 Pro 5G",
        "landingPage": "https://cforcover.com/collections/poco-x7-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_X7_Pro_5G.jpg?v=1737958810"
    },
    {
        "title": "Poco C75 5G",
        "landingPage": " https://cforcover.com/collections/poco-c75-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_C75_5G.jpg?v=1735291792"
    },
    {
        "title": "Poco F6",
        "landingPage": "https://cforcover.com/collections/poco-f6",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_F6.jpg?v=1728298772"
    },
{
      "title": "Poco X6 Pro 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_X6_Pro.jpg?v=1715258885",
      "landingPage": "https://cforcover.com/collections/poco-x6-pro-5g"
},
{
  title: "Poco F3 GT 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-f3-gt.jpg?v=1709099509",
  landingPage: "https://cforcover.com/collections/poco-f3-gt",
},
{
  title: "Poco F1",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Poco_F1.jpg?v=1713430336",
  landingPage: "https://cforcover.com/collections/poco-f1",
},
{
  title: "Poco C61",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_6a0038df-e2a2-4f24-8995-f103ce0ede41.jpg?v=1712216638",
  landingPage: "https://cforcover.com/collections/poco-c61",
},
{
  title: "Poco X6 Neo 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_3493186b-d8f9-4aca-8c48-6f211c6eaed8.jpg?v=1712216751",
  landingPage: "https://cforcover.com/collections/poco-x6-neo-5g",
},
{
  title: "Poco M6 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-m6-5g.jpg?v=1703932698",
  landingPage: "https://cforcover.com/collections/poco-m6-5g",
},
{
  title: "Poco X5 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-x5-5g.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-x5",
},
{
  title: "Poco X5 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-x5-pro-5g.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-x5-pro",
},
{
  title: "Poco M4 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m4-pro-5g.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m4-pro-4g",
},
{
  title: "Poco M4 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m4-pro-5g.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m4-pro-5g",
},
{
  title: "Poco M4 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m4-5g.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m4-5g",
},
{
  title: "Poco C3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-c3.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-c3",
},
{
  title: "Poco C31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-c31.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-c31",
},
{
  title: "Poco C50",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-c50.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-c50",
},
{
  title: "Poco C51",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-c51.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-c51",
},
{
  title: "Poco C55",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-c55.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-c55",
},
{
  title: "Poco F3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-f3-gt.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-f3",
},
{
  title: "Poco F5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-f5.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-f5",
},
{
  title: "Poco M2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m2.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m2",
},
{
  title: "Poco M2 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m2-pro.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m2-pro",
},
{
  title: "Poco M3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m3.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m3",
},
{
  title: "Poco M3 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m3-pro-5g.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m3-pro-5g",
},
{
  title: "Poco M5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m5.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m5",
},
{
  title: "Poco M6 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-m6-pro.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-m6-pro-5g",
},
{
  title: "Poco X2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-x2.jpg?v=1695361524",
  landingPage: "https://coverpe.myshopify.com/collections/poco-x2",
},
{
  title: "Poco X3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-x3.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-x3",
},
{
  title: "Poco X4 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/poco-x4-pro.jpg?v=1695361525",
  landingPage: "https://coverpe.myshopify.com/collections/poco-x4-pro",
},
{
  title: "Poco C65 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-poco-c65.jpg?v=1702981505",
  landingPage: "https://cforcover.com/collections/poco-c65-5g",
},
];

const oppo = [
  {
    "title": "Oppo A6x 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a6x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a6x-5g.jpg?v=1772196465"
  },
  {
    "title": "OPPO Reno 5 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-reno5-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno5-pro-5g.jpg?v=1771937928"
  },
  {
    "title": "Oppo K14x 5G",
    "landingPage": "https://cforcover.com/collections/oppo-k14x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a6t.jpg?v=1772086951"
  },
  {
    "title": "Oppo Reno 15C 5G",
    "landingPage": "https://cforcover.com/collections/oppo-reno-15c-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno-15c.jpg?v=1770804956"
  },
  {
    "title": "Oppo Reno 15 Pro Mini 5G",
    "landingPage": "https://cforcover.com/collections/oppo-reno-15-pro-mini-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno15-pro-global.jpg?v=1768977174"
  },
  {
    "title": "Oppo Reno 15 5G",
    "landingPage": "https://cforcover.com/collections/oppo-reno-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno15.jpg?v=1767002987"
  },
  {
    "title": "Oppo Reno 15 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-reno-15-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno15-pro.jpg?v=1767002987"
  },
  {
    "title": "Oppo A6 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a6-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a6-pro-cn.jpg?v=1764333771"
  },
  {
    "title": "Oppo Find X9 5G",
    "landingPage": "https://cforcover.com/collections/oppo-find-x9-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-find-x9.jpg?v=1766208596"
  },
  {
    "title": "Oppo Find X9 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-find-x9-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-find-x9-pro.jpg?v=1766208595"
  },
  {
    "title": "Oppo F31 5G",
    "landingPage": "https://cforcover.com/collections/oppo-f31-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo_f31_5g.jpg?v=1763791522"
  },
  {
    "title": "Oppo F31 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-f31-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f31-pro.jpg?v=1763791522"
  },
  {
    "title": "Oppo F31 Pro Plus 5G",
    "landingPage": "https://cforcover.com/collections/oppo-f31-pro-plus-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f31-pro-plus.jpg?v=1760445795"
  },
  {
    "title": "Oppo K13 Turbo 5G",
    "landingPage": "https://cforcover.com/collections/oppo-k13-turbo-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-k13-turbo.jpg?v=1756381190"
  },
  {
    "title": "Oppo A3 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a3-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a3-int.jpg?v=1756381190"
  },
  {
    "title": "Oppo A5 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a5-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a5-5g-1.jpg?v=1755339319"
  },
  {
    "title": "Oppo K13x 5G",
    "landingPage": "https://cforcover.com/collections/oppo-k13x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-k13x-5g.jpg?v=1755339320"
  },
    {
    "title": "Oppo A5x 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a5x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a5x.jpg?v=1753194512"
  },
  {
    title: "Oppo K13 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_K13_5G.jpg?v=1748954447",
    landingPage: "https://cforcover.com/collections/oppo-k13-5g"
  },
  {
    title: "Oppo Reno 14 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno14.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/oppo-reno-14-5g"
  },
  {
    title: "Oppo Reno 14 Pro 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno14-pro.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/oppo-reno-14-pro-5g"
  },
  {
    "title": "Oppo A5 Pro 5G",
    "landingPage": "https://cforcover.com/collections/oppo-a5-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A5_Pro_5G.jpg?v=1747483077"
  },
  {
    "title": "Oppo Reno 3 Pro",
    "landingPage": "https://cforcover.com/collections/oppo-reno-3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_3_Pro.jpg?v=1745056352"
  },
      {
        "title": "Oppo F29 5G",
        "landingPage": "https://cforcover.com/collections/oppo-f29-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f29.jpg?v=1742637805"
      },
      {
        "title": "Oppo F29 Pro 5G",
        "landingPage": "https://cforcover.com/collections/oppo-f29-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f29-pro.jpg?v=1742637808"
      },
     {
        "title": "Oppo Find X8 5G",
        "landingPage": "https://cforcover.com/collections/oppo-find-x8-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Find_X8_5G.jpg?v=1737955507"
    },
    {
        "title": "Oppo Find X8 Pro 5G",
        "landingPage": "https://cforcover.com/collections/oppo-find-x8-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Find_X8_Pro_5G.jpg?v=1737955508"
    },
    {
        "title": "Oppo Reno 13 5G",
        "landingPage": "https://cforcover.com/collections/oppo-reno-13-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno13-cn.jpg?v=1737701798"
    },
    {
        "title": "Oppo Reno 13 Pro 5G",
        "landingPage": "https://cforcover.com/collections/oppo-reno-13-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno13-pro-cn.jpg?v=1737701804"
    },
     {
        "title": "OPPO Pad Air",
        "landingPage": "https://cforcover.com/collections/oppo-pad-air",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Pad_Air.jpg?v=1730952146"
    },
     {
        "title": "Oppo A60 5G",
        "landingPage": "https://cforcover.com/collections/oppo-a60-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A60_5G.jpg?v=1728298772"
     },
     {
        "title": "Oppo Find N3 Flip",
        "landingPage": "https://cforcover.com/collections/oppo-find-n3-flip",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Find_N3_Flip.jpg?v=1728298772"
     },
     {
        "title": "Oppo Reno 6 5G",
        "landingPage": "https://cforcover.com/collections/oppo-reno-6-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_6_5G.jpg?v=1728298773"
      },
      {
        "title": "Oppo A3 Pro 5G",
        "landingPage": "https://cforcover.com/collections/oppo-a3-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A3_Pro_5G_a3648a94-85bc-428e-9806-fcb8430e1900.jpg?v=1727765217"
      },
   {
      "title": "Oppo A3x 5G",
      "landingPage": "https://cforcover.com/collections/oppo-a3x-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A3x_5G.jpg?v=1724329045"
   },
  {
      "title": "Oppo F27 Pro Plus 5G",
      "landingPage": "https://cforcover.com/collections/oppo-f27-pro-plus-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_F27_Pro_Plus_5G.jpg?v=1726147388"
  },
  {
      "title": "Oppo K12x 5G",
      "landingPage": "https://cforcover.com/collections/oppo-k12x-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_K12X_5G_d56d8e23-ecd9-46d8-bc43-9473d1eba08e.jpg?v=1727765217"
  },
  {
      "title": "Oppo Reno 12 Pro 5G",
      "landingPage": "https://cforcover.com/collections/oppo-reno-12-pro-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_Pro_12_5G.jpg?v=1727766630"
  },
      {
        "title": "Oppo Reno 12 5G",
        "landingPage": "https://cforcover.com/collections/oppo-reno-12-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_12.jpg?v=1722343406"
      },  
      {
        "title": "Oppo F27 5G",
        "landingPage": "https://cforcover.com/collections/oppo-f27-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_F27_5G.jpg?v=1725454871"
      },
    {
       title: "Oppo Reno 12 Pro 5G",
       imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_12_Pro_5G.webp?v=1721995600",
       landingPage: "https://cforcover.com/collections/oppo-reno-12-pro-5g"
    },
    {
       title: "Oppo A3 Pro 5G",
       imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A3_Pro_5G.jpg?v=1720509012",
       landingPage: "https://cforcover.com/collections/oppo-a3-pro-5g"
   },
   {
       title: "Oppo F27 Pro Plus 5G",
       imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_AF27_Pro_Plus.jpg?v=1720509012",
       landingPage: "https://cforcover.com/collections/oppo-f27-pro-plus-5g"
   },
  {
        title: "Oppo Reno 11 Pro 5G",
        imagePath:
          "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno11-china.jpg?v=1706266704",
        landingPage: "https://cforcover.com/collections/oppo-reno-11-pro-5g",
  }, 
 {
   title: "Oppo Reno 11 5G",
   imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno11-international.jpg?v=1706266703",
   landingPage: "https://cforcover.com/collections/oppo-reno-11-5g",
},
{
  title: "Oppo F25 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f25-pro.jpg?v=1710150996",
  landingPage: "https://cforcover.com/collections/oppo-f25-pro-5g",
},
{
  title: "Oppo F21s Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_F21s_Pro_5G.jpg?v=1713430266",
  landingPage: "https://cforcover.com/collections/oppo-f21s-pro-5g",
},
{
  title: "Oppo F19 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19_d8e5446b-0950-4447-ad53-a242820bc84c.jpg?v=1709099509",
  landingPage: "https://cforcover.com/collections/oppo-f19-4g",
},
{
  title: "Oppo A11k",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a11k.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a11k",
},
{
  title: "Oppo A11x",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a11k.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a11x",
},
{
  title: "Oppo A12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a12.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a12",
},
{
  title: "Oppo A15",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a15_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a15",
},
{
  title: "Oppo A15s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a15s.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a15s",
},
{
  title: "Oppo A16",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a16_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a16",
},
{
  title: "Oppo A16e",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a16e.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a16e",
},
{
  title: "Oppo A16K",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a16k.jpg?v=1694410841",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a16k-1",
},
{
  title: "Oppo A17",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a17_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a17",
},
{
  title: "Oppo A17K",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a17k.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a17k",
},
{
  title: "Oppo A18",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a18.jpg?v=1699432584",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a18",
},
{
  title: "Oppo F7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_F7.jpg?v=1713430287",
  landingPage: "https://cforcover.com/collections/oppo-f7",
},
{
  title: "Oppo A31 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_A31_2020.jpg?v=1694410843",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a31-2020",
},
{
  title: "Oppo A32",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a32.jpg?v=1699429581",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a32",
},
{
  title: "Oppo A33 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a33-2020.jpg?v=1699432584",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a33-2020",
},
{
  title: "Oppo A36",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a36.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a36",
},
{
  title: "Oppo A37",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a37_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a37",
},
{
  title: "Oppo A38 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a38.jpg?v=1698834499",
  landingPage: "https://cforcover.com/collections/oppo-a38-4g",
},
{
  title: "Oppo A3s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a3s_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a3s",
},
{
  title: "Oppo A5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a5-2020_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a5-4g",
},
{
  title: "Oppo A5 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a5-2020.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a5-2020",
},
{
  title: "Oppo A52 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a52.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a52",
},
{
  title: "Oppo A53 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a53-2020.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a53-2020",
},
{
  title: "Oppo A53s 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a53s-5g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a53s-5g",
},
{
  title: "Oppo A54 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a54_3e2bc69d-da69-4bc0-99fb-ebdb3e28c417.jpg?v=1698834499",
  landingPage: "https://cforcover.com/collections/oppo-a54-4g",
},
{
  title: "Oppo A55 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a55-4g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a55-4g-2",
},
{
  title: "Oppo A55 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a55-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a55-5g",
},
{
  title: "Oppo A57 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a57-4g.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a57-2022",
},

{
  title: "Oppo A58 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a58-4g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a58-4g",
},
{
  title: "Oppo A58 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a58-4g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a58-5g",
},
{
  title: "Oppo A59",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a59.jpg?v=1699429581",
  landingPage: "https://cforcover.com/collections/oppo-a59",
},
{
  title: "Oppo A5s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a5s.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a5s",
},
{
  title: "Oppo A7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a7.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/oppo-a7",
},
{
  title: "Oppo A73",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a73.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/oppo-a73",
},
{
  title: "Oppo A76",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a76.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a76",
},
{
  title: "Oppo A77",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a77-5g_a2889606-7d24-43ab-9ceb-b87aa846757e.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a77",
},
{
  title: "Oppo A77 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a77-5g_a2889606-7d24-43ab-9ceb-b87aa846757e.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a77-2022",
},
{
  title: "Oppo A77s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a77s_3ad97e37-a76e-4d0b-84d9-78bbfab12f8d.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a77s",
},
{
  title: "Oppo A78",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a78-4g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a78-4g",
},
{
  title: "Oppo A78 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a78-4g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a78-4g",
},
{
  title: "Oppo A78 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a58_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a78-5g",
},
{
  title: "Oppo A83",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a83.jpg?v=1699432493",
  landingPage: "https://cforcover.com/collections/oppo-a83",
},
{
  title: "Oppo A9 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a9-2020.jpg?v=1694410841",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a9-2020",
},
{
  title: "Oppo A91",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a91.jpg?v=1699432493",
  landingPage: "https://cforcover.com/collections/oppo-a91",
},
{
  title: "Oppo A93",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a93.jpg?v=1699432493",
  landingPage: "https://cforcover.com/collections/oppo-a93",
},
{
  title: "Oppo A94",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-renp-a94.jpg?v=1699432493",
  landingPage: "https://cforcover.com/collections/oppo-a94",
},
{
  title: "Oppo A96 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a96-new_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-a96-4g",
},
{
  title: "Oppo F11 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f11-pro.jpg?v=1694410842",
  landingPage: "https://cforcover.com/collections/oppo-f11-pro",
},
{
  title: "Oppo F15",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f15-cph2001.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f15",
},
{
  title: "Oppo F17",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f17.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f17",
},
{
  title: "Oppo F17 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f17-pro.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f17-pro",
},
{
  title: "Oppo F19 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19-pro-r_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f19-pro",
},
{
  title: "Oppo F19 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19-pro-r_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f19-pro-4g",
},
{
  title: "Oppo F19 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19-pro-r_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f19-pro-5g",
},
{
  title: "Oppo F19 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19-pro-plus-r_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/oppo-f19-pro-plus-5g",
},
{
  title: "Oppo F19 Pro+ 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f19-pro-plus-r_0d224fce-0fb7-4f9e-8081-1fcd4de95c59.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f19-pro-+-5g",
},
{
  title: "Oppo F1S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f1s.jpg?v=1699429581",
  landingPage: "https://cforcover.com/collections/oppo-f1s",
},
{
  title: "Oppo Reno 6 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_Reno_6_Pro_5G.jpg?v=1713430306",
  landingPage: "https://cforcover.com/collections/oppo-reno-6-pro-5g",
},
{
  title: "Oppo F21 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7-4g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f21-pro",
},
{
  title: "Oppo F21 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7-4g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f21-pro-4g",
},
{
  title: "Oppo F21 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7-z-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f21-pro-5g",
},
{
  title: "Oppo F21s Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_F21_Pro_4G.jpg?v=1694410843",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f21s-pro",
},
{
  title: "Oppo F23",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f23-5g.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f23",
},
{
  title: "Oppo F9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f9_217af551-06aa-4594-88c1-fac59b7b19a4.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/oppo-f9",
},
{
  title: "Oppo F9 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-f9.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-f9-pro",
},
{
  title: "Oppo K10 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-k10.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-k10",
},
{
  title: "Oppo K10 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-k10-5g_f114d8c3-62bc-41c5-8365-f95155f3de71.jpg?v=1687426317",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-k10-5g",
},
{
  title: "Oppo K3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-k3.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-k3",
},
{
  title: "Oppo Reno 2F",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Reno_2Z.jpg?v=1694410841",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-2f",
},
{
  title: "Oppo Reno 2Z",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Reno_2Z.jpg?v=1694410841",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-2z",
},
{
  title: "Oppo Reno 5 Lite",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno-5-lite.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/oppo-reno-5-lite",
},
{
  title: "Oppo Reno 5F",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno5-F.jpg?v=1699448619",
  landingPage: "https://cforcover.com/collections/oppo-reno-5f",
},
{
  title: "Oppo Reno 5 Z 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno-5Z.jpg?v=1699448620",
  landingPage: "https://cforcover.com/collections/oppo-reno-5z-5g",
},
{
  title: "Oppo Reno 7 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7-4g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-7-4g",
},
{
  title: "Oppo Reno 7 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-7-5g",
},
{
  title: "Oppo Reno 7 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno7-pro-r_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-7-pro-5g",
},
{
  title: "Oppo Reno 8 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Reno8_5G.jpg?v=1694410842",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno8-5g",
},
{
  title: "Oppo Reno 8 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno8-pro_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-8-pro-5g",
},
{
  title: "Oppo Reno 8 Pro Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno8-pro_e134d134-7d80-40f2-8176-07138a1aa3bb.jpg?v=1687426240",
  landingPage:
    "https://coverpe.myshopify.com/collections/oppo-reno-8-pro-plus",
},
{
  title: "Oppo Reno 8T 5 G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno8-t_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno-8t-5g",
},
{
  title: "Oppo Reno10 Pro+ 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Reno10_Pro_5G.jpg?v=1694410841",
  landingPage:
    "https://coverpe.myshopify.com/collections/oppo-reno10-pro-+-5g",
},
{
  title: "Oppo Reno8 T 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Reno8_T_5G.jpg?v=1694410841",
  landingPage: "https://coverpe.myshopify.com/collections/oppo-reno8-t-5g",
},
{
  title: "Oppo A59 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Oppo_A59_5G.jpg?v=1713430241",
  landingPage: "https://cforcover.com/collections/oppo-a59",
},
{
  title: "Oppo A79 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a79-5g.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/oppo-a79-5g",
},
{
  title: "Oppo A72 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a72.jpg?v=1702981505",
  landingPage: "https://cforcover.com/collections/oppo-a72-4g",
},
{
  title: "Oppo A92 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-a92.jpg?v=1702981505",
  landingPage: "https://cforcover.com/collections/oppo-a92-4g",
},
{
  title: "Oppo Reno 3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno3-lte-r.jpg?v=1702981506",
  landingPage: "https://cforcover.com/collections/oppo-reno-3",
},
{
  title: "Oppo Reno 10 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-reno10-pro-international.jpg?v=1702981505",
  landingPage: "https://cforcover.com/collections/oppo-reno-10-pro-5g",
},
{
      "title": "OPPO Pad Air",
      "landingPage": "https://cforcover.com/collections/oppo-pad-air",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_12c713fc-8fdb-4c7b-9cda-7bb3ec63d5b8.jpg?v=1710910094"
},
];

const infinix = [
  {
    "title": "Infinix Note 50 5G",
    "landingPage": "https://cforcover.com/collections/infinix-note-50-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note50.jpg?v=1756381190"
  },
  {
    "title": "Infinix Note 40 Pro 5G",
    "landingPage": "https://cforcover.com/collections/infinix-note-40-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-40-pro-5g.jpg?v=1756381190"
  },
  {
    "title": "Infinix GT 30 Pro 5G",
    "landingPage": "https://cforcover.com/collections/infinix-gt-30-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-gt30-pro.jpg?v=1755339320"
  },
  {
    "title": "Infinix Note 40x",
    "landingPage": "https://cforcover.com/collections/infinix-note-40x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note40x-5g.jpg?v=1755339319"
  },
  {
    "title": "Infinix Note 50s 5G",
    "landingPage": "https://cforcover.com/collections/infinix-note-50s-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-50s.jpg?v=1755339319"
  },
    {
    "title": "Infinix Note 50x",
    "landingPage": "https://cforcover.com/collections/infinix-note-50x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-50x.jpg?v=1753194512"
  },
          {
          "title": "Infinix Smart 10 5G",
          "landingPage": "https://cforcover.com/collections/infinix-smart-10-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-10.jpg?v=1753703522"
        },
  {
    "title": "Infinix GT 20 Pro 5G",
    "landingPage": "https://cforcover.com/collections/infinix-gt-20-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_GT_20_Pro_5G.jpg?v=1745056294"
  },
  {
    "title": "Infinix Note 40 5G",
    "landingPage": "https://cforcover.com/collections/infinix-note-40-4g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_Note_40_5g.jpg?v=1745056307"
  },
  {
    "title": "Infinix Smart 9 HD",
    "landingPage": "https://cforcover.com/collections/infinix-smart-9-hd",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-9-hd.jpg?v=1742637447"
  },
  {
      "title": "Infinix Zero 30 4G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-zero-30-4g.jpg?v=1707802499",
      "landingPage": "https://cforcover.com/collections/infinix-zero-30-4g",
  },
 {
        "title": "Infinix Smart 8 HD",
        "imagePath":
          "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-8-hd.jpg?v=1703933146",
        "landingPage": "https://cforcover.com/collections/infinix-smart-8-hd",
 },
 {
      "title": "Infinix Zero 2023 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_Zero_2023_5G.jpg?v=1714382379",
      "landingPage": "https://cforcover.com/collections/infinix-zero-2023-5g"
  },
  {
      "title": "Infinix Hot 30 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_Hot_30_5G.jpg?v=1714382379",
      "landingPage": "https://cforcover.com/collections/infinix-hot-30-5g"
  },
{
  title: "Infinix GT 10 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-gt10-pro-5g_be5eb1a6-384b-4386-91c4-f5230fedffe1.jpg?v=1708151527",
  landingPage: "https://cforcover.com/collections/infinix-gt-10-pro",
},
{
  title: "Infinix Smart 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-smart-6",
},
{
  title: "Infinix Smart 6 HD",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6-hd_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-smart-6-hd",
},
{
  title: "Infinix Smart 6 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6-hd.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-smart-6-plus",
},
{
  title: "Infinix Smart HD 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-hd-2021.jpg?v=1695201815",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-smart-hd-2021",
},
{
  title: "Infinix Zero 20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-zero20.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-zero-20",
},
{
  title: "Infinix Hot 20 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot20-5g.jpg?v=1695201814",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-20-5g",
},
{
  title: "Infinix Hot 20 Play",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot20-5g.jpg?v=1695201814",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-hot-20-play",
},
{
  title: "Infinix Hot 30i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot-30i.jpg?v=1699426848",
  landingPage: "https://cforcover.com/collections/infinix-hot-30i",
},
{
  title: "Infinix Note 12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-12",
},
{
  title: "Infinix Note 12 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12-pro.jpg?v=1695201815",
  landingPage: "https://cforcover.com/collections/infinix-note-12-pro-4g",
},
{
  title: "Infinix Note 12 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12-pro.jpg?v=1695201815",
  landingPage: "https://cforcover.com/collections/infinix-note-12-pro-5g",
},
{
  title: "Infinix Note 12i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12i.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-12i",
},
{
  title: "Infinix Hot 10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot10_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-10",
},
{
  title: "Infinix Hot 10 Play",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot10-play_60x60.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-hot-10-play",
},
{
  title: "Infinix Hot 10i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot-10i.jpg?v=1699426848",
  landingPage: "https://cforcover.com/collections/infinix-hot-10i",
},
{
  title: "Infinix Hot 10S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_Hot_10S.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-10s",
},
{
  title: "Infinix Hot 11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot-11-2022.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-11",
},
{
  title: "Infinix Hot 11 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot11-play_60x60.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-hot-11-2022",
},
{
  title: "Infinix Hot 11S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot11s.jpg?v=1695201814",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-11s",
},
{
  title: "Infinix Hot 12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Infinix_Hot_12.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-12",
},
{
  title: "Infinix Hot 12 Play",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot20-play.jpg?v=1695201815",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-hot-12-play",
},
{
  title: "Infinix Hot 12 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot12-pro.jpg?v=1695201814",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-12-pro",
},
{
  title: "Infinix Hot 20 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot20-5g.jpg?v=1695201814",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-20-5g",
},
{
  title: "Infinix Hot 20 Play",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot20-5g.jpg?v=1695201814",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-hot-20-play",
},
{
  title: "Infinix Hot 30i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot-30i.jpg?v=1699426848",
  landingPage: "https://cforcover.com/collections/infinix-hot-30i",
},
{
  title: "Infinix Hot 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot-s8_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-8",
},
{
  title: "Infinix Hot 9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot9_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-9",
},
{
  title: "Infinix Hot 9 Play",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot9-play_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-9-play",
},
{
  title: "Infinix Hot 9 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-hot9_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-hot-9-pro",
},
{
  title: "Infinix Note 10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-10_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-10",
},
{
  title: "Infinix Note 10 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-10-pro.jpg?v=1695201815",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-note-10-pro",
},
{
  title: "Infinix Note 11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note11_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-11",
},
{
  title: "Infinix Note 11 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note11_60x60.jpg?v=1687418411",
  landingPage: "https://cforcover.com/collections/infinix-note-11-pro",
},
{
  title: "Infinix Note 11S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note-11s.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-11s",
},
{
  title: "Infinix Note 12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-12",
},
{
  title: "Infinix Note 12 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12-pro.jpg?v=1695201815",
  landingPage: "https://cforcover.com/collections/infinix-note-12-pro-4g",
},
{
  title: "Infinix Note 12 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12-pro.jpg?v=1695201815",
  landingPage: "https://cforcover.com/collections/infinix-note-12-pro-5g",
},
{
  title: "Infinix Note 12i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-note12i.jpg?v=1695201815",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-note-12i",
},
{
  title: "Infinix Smart 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart5_1a50a9d2-7d1b-44c0-9d67-ab51f7766f98.jpg?v=1687425998",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-smart-5",
},
{
  title: "Infinix Smart 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-smart-6",
},
{
  title: "Infinix Smart 6 HD",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6-hd_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/infinix-smart-6-hd",
},
{
  title: "Infinix Smart 6 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-6-hd.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-smart-6-plus",
},
{
  title: "Infinix Smart HD 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/infinix-smart-hd-2021.jpg?v=1695201815",
  landingPage:
    "https://coverpe.myshopify.com/collections/infinix-smart-hd-2021",
},
];

const apple = [
  {
    "title": "Apple iPhone 17",
    "landingPage": "https://cforcover.com/collections/apple-iphone-17",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-16.jpg?v=1755339319"
  },
  {
    "title": "Apple iPhone 17 Air",
    "landingPage": "https://cforcover.com/collections/apple-iphone-17-air",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-17-air-r.jpg?v=1755339319"
  },
  {
    "title": "Apple iPhone 17 Pro",
    "landingPage": "https://cforcover.com/collections/apple-iphone-17-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-17-pro-max-r.jpg?v=1755339319"
  },
  {
    "title": "Apple iPhone 17 Pro Max",
    "landingPage": "https://cforcover.com/collections/apple-iphone-17-pro-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-17-pro-max-r.jpg?v=1755339319"
  },
    {
      "title": "Apple iPhone 16e",
      "landingPage": "https://cforcover.com/collections/apple-iphone-16e",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_16E.jpg?v=1742021414"
    },
    {
        "title": "Apple iPhone 13 Mini",
        "landingPage": "https://cforcover.com/collections/apple-iphone-13-mini",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_13_Mini.jpg?v=1728298772"
    },
    {
        "title": "Apple iPhone 6 Plus",
        "landingPage": "https://cforcover.com/collections/apple-iphone-6-plus",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_6_Plus.jpg?v=1728298772"
    },
    {
        "title": "Apple iPhone 6s",
        "landingPage": "https://cforcover.com/collections/apple-iphone-6s",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_6s_d1d571ed-8c1d-4db9-bb40-47bf372e071b.jpg?v=1728298772"
    },
   {
      "title": "Apple iPhone 16",
      "landingPage": "https://cforcover.com/collections/apple-iphone-16",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_16.jpg?v=1727776215"
   },
  {
      "title": "Apple iPhone 16 Plus",
      "landingPage": "https://cforcover.com/collections/apple-iphone-16-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_16_Plus.jpg?v=1727776215"
  },
  {
      "title": "Apple iPhone 16 Pro",
      "landingPage": "https://cforcover.com/collections/apple-iphone-16-pro",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_16_Pro.jpg?v=1727776215"
  },
  {
      "title": "Apple iPhone 16 Pro Max",
      "landingPage": "https://cforcover.com/collections/apple-iphone-16-pro-max",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_16_Pro_Max.jpg?v=1727776215"
  },
{
  title: "Apple iPhone 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_6.png?v=1694414876",
  landingPage: "https://cforcover.com/collections/apple-iphone-6",
},
{
  title: "Apple iPhone 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-5-ofic.jpg?v=1706266703",
  landingPage: "https://cforcover.com/collections/apple-iphone-5",
},
{
  title: "Apple iPhone 15",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-15.jpg?v=1698825996",
  landingPage: "https://cforcover.com/collections/apple-iphone-15",
},
{
  title: "Apple iPhone 15 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-15-pro.jpg?v=1698825995",
  landingPage: "https://cforcover.com/collections/apple-iphone-15-pro",
},
{
  title: "Apple iPhone 15 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-15-plus.jpg?v=1698825996",
  landingPage: "https://cforcover.com/collections/apple-iphone-15-plus",
},
{
  title: "Apple iPhone 15 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-15-pro-max.jpg?v=1698825996",
  landingPage: "https://cforcover.com/collections/apple-iphone-15-max",
},
{
  title: "Apple iPhone 14",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-14_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-14",
},
{
  title: "Apple iPhone 14 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_14_Plus.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-14-plus",
},
{
  title: "Apple iPhone 14 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_14_Pro.png?v=1694435262",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-14-pro",
},
{
  title: "Apple iPhone 14 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_14Pro_max.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-14-pro-max",
},
{
  title: "Apple iPhone 13",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-13_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-13",
},
{
  title: "Apple iPhone 13 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-13-pro_60x60.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-13-pro",
},
{
  title: "Apple iPhone 13 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-13-pro-max_60x60.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-13-pro-max",
},
{
  title: "Apple iPhone 12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-12_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-12",
},
{
  title: "Apple iPhone 12 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-12-pro_eb58fd32-81e8-4289-819a-9e4a7ab035c5.jpg?v=1687426075",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-12-pro",
},
{
  title: "Apple iPhone 12 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPhone_12_Pro_max_1.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-12-pro-max",
},
{
  title: "Apple iPhone 12 Mini",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPhone_12_Mini.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-12-mini",
},
{
  title: "Apple iPhone 11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-11_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-11",
},
{
  title: "Apple iPhone 11 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iphone11_pro_2.png?v=1694414878",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-11-pro",
},
{
  title: "Apple iPhone 11 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPhone_11_Pro_max.png?v=1694414877",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-11-pro-max",
},
{
  title: "Apple iPhone 7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_7.png?v=1694414876",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-7",
},
{
  title: "Apple iPhone 7 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_7_Plus.png?v=1694414874",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-7-plus",
},
{
  title: "Apple iPhone 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_8.png?v=1694414876",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-9",
},
{
  title: "Apple iPhone 8 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_8_Plus.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-8-plus",
},
{
  title: "Apple iPhone SE 2020",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_SE_2020.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-se-2020",
},
{
  title: "Apple iPhone SE 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_SE_2022.png?v=1694414876",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-se-2022",
},
{
  title: "Apple iPhone X",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_X_1.png?v=1694414877",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-x",
},
{
  title: "Apple iPhone XS",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_XS.png?v=1694414877",
  landingPage: "https://coverpe.myshopify.com/collections/apple-iphone-xs",
},
{
  title: "Apple iPhone XS Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPhone_XS_max.png?v=1694414877",
  landingPage:
    "https://coverpe.myshopify.com/collections/apple-iphone-xs-max",
},
{
  title: "Apple iPhone XR",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-iphone-xr-new_0c443c0c-ff19-4c79-b8ab-a9b97d10a4e2.jpg?v=1702624482",
  landingPage: "https://cforcover.com/collections/apple-iphone-xr",
},
{
      "title": "Apple iPad(6th Gen)",
      "landingPage": "https://cforcover.com/collections/apple-ipad-6th-generation",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b1160748-501c-4ce0-b145-d8dbb6e7a77b.jpg?v=1710849350"
  },
 
  {
      "title": "Apple iPad(9th Gen)10.2",
      "landingPage": "https://cforcover.com/collections/apple-ipad-9th-generation-10-2",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_a4ed8563-1487-4ea6-a85f-f169c9bc5777.jpg?v=1710850652"
  },
  {
      "title": "Apple iPad(10th Gen)10.9",
      "landingPage": "https://cforcover.com/collections/apple-ipad-10th-generation-10-9",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_4f76d9b5-cf77-4cce-93f1-fbca0103872b.jpg?v=1710850862"
  },
  
  {
      "title": "Apple iPad 3",
      "landingPage": "https://cforcover.com/collections/apple-ipad-3",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_86c1a6e1-25ec-4fd7-9383-dd34c284b705.jpg?v=1710851015"
  },
  {
      "title": "Apple iPadMini(6th Gen)",
      "landingPage": "https://cforcover.com/collections/apple-ipad-mini-6th-generation",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_46a349c3-2973-4d06-a21b-85bb74443904.jpg?v=1710851273"
  },
  {
      "title": "Apple iPadmini2 (7.9)",
      "landingPage": "https://cforcover.com/collections/apple-ipad-mini-2-7-9",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_d940e280-4a99-44c2-9c15-cdd2f5414ae2.jpg?v=1710851361"
  },
  {
      "title": "Apple iPad mini 4",
      "landingPage": "https://cforcover.com/collections/apple-ipad-mini-4",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_7666c7f3-34ed-4ed2-9c60-ba45a644281c.jpg?v=1710851436"
  },
  {
      "title": "Apple iPad Pro(2020) 11",
      "landingPage": "https://cforcover.com/collections/apple-ipad-pro-2020-11",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_96389260-eb90-4091-b5bd-b71e15a161c1.jpg?v=1710851514"
  },
  {
      "title": "Apple iPad Pro 12.9",
      "landingPage": "https://cforcover.com/collections/apple-ipad-pro-12-9",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_09a44c11-37a6-4006-b054-54f747e9c313.jpg?v=1710851585"
  },
  {
        "title": "Apple iPad Mini (6th Generation)",
        "landingPage": "https://cforcover.com/collections/apple-ipad-mini-6th-generation",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_Mini_6th_Gen.jpg?v=1730954735"
    },
    {
        "title": "Apple iPad mini 2",
        "landingPage": "https://cforcover.com/collections/apple-ipad-mini-2-7-9",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_mini_2.jpg?v=1730954304"
    },
    {
        "title": "Apple iPad mini 3",
        "landingPage": "https://cforcover.com/collections/apple-ipad-mini-3",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_mini_3.jpg?v=1730954605"
    },
    {
        "title": "Apple iPad mini 4",
        "landingPage": "https://cforcover.com/collections/apple-ipad-mini-4",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_mini_2.jpg?v=1730954304"
    },


];

const samsung = [
  {
    "title": "Samsung M17e 5G",
    "landingPage": "https://cforcover.com/collections/samsung-m17e-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m17e.jpg?v=1774258776"
  },
  {
    "title": "Samsung A06 4G",
    "landingPage": "https://cforcover.com/collections/samsung-a06-4g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a06-11.jpg?v=1724830924"
  },
  {
    "title": "Samsung M07",
    "landingPage": "https://cforcover.com/collections/samsung-m07",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m07.jpg?v=1771047983"
  },
  {
    "title": "Samsung F07",
    "landingPage": "https://cforcover.com/collections/samsung-f07",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f07.jpg?v=1771047984"
  },
  {
    "title": "Samsung F70e 5G",
    "landingPage": "https://cforcover.com/collections/samsung-f70e-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f70e.jpg?v=1770804958"
  },
   {
    "title": "Samsung S20 ultra",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-s20-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s20-ultra_e51a5635-e997-47ab-946f-e3f7ec092606.jpg?v=1768799904"
  },
  {
    "title": "Samsung Note 10",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-note-10",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-note10.jpg?v=1768895740"
  },
  {
    "title": "Samsung S26 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s26-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S26_5G.jpg?v=1767939268"
  },
  {
    "title": "Samsung S26 Plus 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s26-plus-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s26-plus.jpg?v=1767939268"
  },
  {
    "title": "Samsung F17 5G",
    "landingPage": "https://cforcover.com/collections/samsung-f17-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f17-5g_626cbe51-d99a-40e9-b004-dfc6816cdc17.jpg?v=1767002988"
  },
  {
    "title": "Samsung A37 5G",
    "landingPage": "https://cforcover.com/collections/samsung-a37-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a36_1.jpg?v=1767003081"
  },
  {
    "title": "Samsung A57 5G",
    "landingPage": "https://cforcover.com/collections/samsung-a57-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a56.jpg?v=1767003111"
  },
  {
    "title": "Samsung S26 Ultra 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s26-ultra-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s25-ultra-sm-s938.jpg?v=1766208596"
  },
  {
    "title": "Samsung M17 5G",
    "landingPage": "https://cforcover.com/collections/samsung-m17-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a17.jpg?v=1766208596"
  },
  {
    "title": "Samsung A07 5G",
    "landingPage": "https://cforcover.com/collections/samsung-a07-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a07.jpg?v=1757755300"
  },
  {
    "title": "Samsung A17 5G",
    "landingPage": "https://cforcover.com/collections/samsung-a17-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a17-5g.jpg?v=1756381190"
  },
  {
    "title": "Samsung S25 FE 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s25-fe-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s25-fe-r.jpg?v=1755339319"
  },
    {
    "title": "Samsung Z Flip 7",
    "landingPage": "https://cforcover.com/collections/samsung-z-flip-7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-z-flip7.jpg?v=1753194512"
    },
    {
    "title": "Samsung M36 5G",
    "landingPage": "https://cforcover.com/collections/samsung-m36-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m36.jpg?v=1753194512"
  },
    {
    "title": "Samsung F36 5G",
    "landingPage": "https://cforcover.com/collections/samsung-f36-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f36-1.jpg?v=1753194512"
  },
    {
    "title": "Samsung Z Fold 7",
    "landingPage": "https://cforcover.com/collections/samsung-z-fold-7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-z-fold7_1.jpg?v=1753194512"
  },
    {
    title: "Samsung F56 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_F56_5G.jpg?v=1748954447",
    landingPage: "https://cforcover.com/collections/samsung-f56-5g"
  },
  {
    title: "Samsung M56 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M56_5G.jpg?v=1748954447",
    landingPage: "https://cforcover.com/collections/samsung-m56-5g"
  },
  {
    "title": "Samsung M06 5G",
    "landingPage": "https://cforcover.com/collections/samsung-m06-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m06-5g.jpg?v=1746695908"
  },
  {
    "title": "Samsung S21 5G",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-s21",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s21-5g-r.jpg?v=1745478196"
  },
  {
    "title": "Samsung S25 Edge 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s25-edge-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S25_Edge_7e65118f-bdd7-49b7-835a-df7db696d383.jpg?v=1745995319"
  },
  {
    "title": "Samsung S25 Edge 5G",
    "landingPage": "https://cforcover.com/collections/samsung-s25-edge-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S25_Edge_5G.jpg?v=1747483077"
  },
  {
    "title": "Samsung A26 5G",
    "landingPage": "https://cforcover.com/collections/samsung-a26-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A26_5G.jpg?v=1745056300"
  },
  {
    "title": "Samsung M05",
    "landingPage": "https://cforcover.com/collections/samsung-m05",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M05.jpg?v=1745056317"
  },
  {
    "title": "Samsung F06 5G",
    "landingPage": "https://cforcover.com/collections/samsung-f06-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f06-5g_1.jpg?v=1742638565"
  },
  {
    "title": "Samsung F16 5G",
    "landingPage": "https://cforcover.com/collections/samsung-f16-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f16-5g.jpg?v=1742638316"
  },
  {
    "title": "Samsung M16 5G",
    "landingPage": "https://cforcover.com/collections/samsung-m16-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m16-5g.jpg?v=1742638313"
  },
     {
        "title": "Samsung A56 5G",
        "landingPage": "https://cforcover.com/collections/samsung-a56-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A56_5G.jpg?v=1737959881"
    },
     {
        "title": "Samsung A36 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A36.jpg?v=1737090346",
        "landingPage": "https://cforcover.com/collections/samsung-a36-5g"
    },
    {
        "title": "Samsung S25 Plus 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s24-plus-5g-sm-s926_08d43e22-0258-4baa-934f-a5fd452998f7.jpg?v=1737192423",
        "landingPage": "https://cforcover.com/collections/samsung-s25-plus-5g"
    },
    {
        "title": "Samsung S25 Ultra 5G",
        "landingPage": "https://cforcover.com/collections/samsung-s25-ultra-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S25_Ultra.jpg?v=1733226683"
    },
    {
        "title": "Samsung S25 5G",
        "landingPage": "https://cforcover.com/collections/samsung-s25-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S25_5G.jpg?v=1733226683"
    },
     {
        "title": "Samsung A16 5G",
        "landingPage": "https://cforcover.com/collections/samsung-a16-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A16_5G.jpg?v=1731569697\n"
    },
    {
        "title": "Samsung A01 Core",
        "landingPage": "https://cforcover.com/collections/samsung-a01-core",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A01_Core.jpg?v=1728298772"
    },
    {
        "title": "Samsung F55 5G",
        "landingPage": "https://cforcover.com/collections/samsung-f55-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_F55_5G_04214959-dc93-4a0b-b525-c597da3b7533.jpg?v=1728298772"
    },
    {
        "title": "Samsung M01 Core",
        "landingPage": "https://cforcover.com/collections/samsung-galaxy-m01-core",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M01_Core.jpg?v=1728298773"
    },
    {
        "title": "Samsung M35 5G",
        "landingPage": "https://cforcover.com/collections/samsung-m35-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M35_5G_b8175a56-d8a4-4953-b733-bc085491fac7.jpg?v=1728298772"
    },
    {
        "title": "Samsung M55s 5G",
        "landingPage": "https://cforcover.com/collections/samsung-m55s-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M55s_5G.jpg?v=1728298773"
    },
    {
        "title": "Samsung Note 8",
        "landingPage": "https://cforcover.com/collections/samsung-galaxy-note-8",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Note_8.jpg?v=1728298772"
    },
    {
        "title": "Samsung S21 Ultra",
        "landingPage": "https://cforcover.com/collections/samsung-galaxy-s21-ultra",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S21_Ultra.jpg?v=1728298772"
    },
    {
        "title": "Samsung S7 Edge",
        "landingPage": "https://cforcover.com/collections/samsung-s7-edge",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S7_Edge.jpg?v=1728298772"
    },
    {
        "title": "Samsung Z Fold 2",
        "landingPage": "https://cforcover.com/collections/samsung-z-fold-2",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Fold_2.jpg?v=1728298772"
    },
   
   {
      "title": "Samsung S21 Plus 5G",
      "landingPage": "https://cforcover.com/collections/samsung-galaxy-s21-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S21_Plus_5G.jpg?v=1727765217"
   },
  {
      "title": "Samsung S22 Plus 5G",
      "landingPage": "https://cforcover.com/collections/samsung-galaxy-s22-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S22_Plus_5G.jpg?v=1727765708"
  },
  {
      "title": "Samsung A06",
      "landingPage": "https://cforcover.com/collections/samsung-a06-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a06-11.jpg?v=1724830924"
  },
  {
      "title": "Samsung F05",
      "landingPage": "https://cforcover.com/collections/samsung-f05",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_F05.jpg?v=1727766715"
  },
  {
      "title": "Samsung S20 5G",
      "landingPage": "https://cforcover.com/collections/samsung-s20-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S20_5G.jpg?v=1727765217"
  },
  {
      "title": "Samsung S24 FE 5G",
      "landingPage": "https://cforcover.com/collections/samsung-s24-fe-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S24_FE_5G.jpg?v=1727765217"
  },
  {
      "title": "Samsung Z Flip 3",
      "landingPage": "https://cforcover.com/collections/samsung-galaxy-z-flip-3",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Flip_3.jpg?v=1727767283"
  },
  {
      "title": "Samsung Z flip 6",
      "landingPage": "https://cforcover.com/collections/samsung-flip-6",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Flip_6.jpg?v=1722515989"
  },
  {
      "title": "Samsung Z Fold 3",
      "landingPage": "https://cforcover.com/collections/samsung-galaxy-z-fold-3",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Fold_3.jpg?v=1722516453"
  },
  {
      "title": "Samsung Z Fold 4",
      "landingPage": "https://cforcover.com/collections/samsung-z-fold-4",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Fold_4.jpg?v=1722515802"
  },
  {
      "title": "Samsung Z Fold 6",
      "landingPage": "https://cforcover.com/collections/samsung-fold-6",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Z_Fold_6.jpg?v=1722515685"
  },
   {
      "title": "Samsung A06 5G",
      "landingPage": "https://cforcover.com/collections/samsung-a06-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a06-11.jpg?v=1724830924"
  },
  {
      "title": "Samsung J4 Plus",
      "landingPage": "https://cforcover.com/collections/samsung-j4-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j4-plus-sm-j415f.jpg?v=1724831135"
  },
  {
      "title": "Samsung S8",
      "landingPage": "https://cforcover.com/collections/samsung-s8",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s8.jpg?v=1724831139"
  },
 
  {
      "title": "Samsung S20 Plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S20_Plus.jpg?v=1715860488",
      "landingPage": "https://cforcover.com/collections/samsung-galaxy-s20-plus"
  },
  {
      "title": "Samsung J2 Plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_J2_Plus.jpg?v=1715860488",
      "landingPage": "https://cforcover.com/collections/samsung-j2-plus"
  },  
  {
      "title": "Samsung M55 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_M55_5G.jpg?v=1715258885",
      "landingPage": "https://cforcover.com/collections/samsung-m55-5g"
  },
  {
     "title": "Samsung Note 20 Ultra 5G",
     "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Note_20_Ultra_5G.png?v=1694417428",
     "landingPage": "https://cforcover.com/collections/samsung-galaxy-note-20-ultra-5g"
  },
{
    "title": "Samsung A35 5G",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a35-r.jpg?v=1704346301",
    "landingPage": "https://cforcover.com/collections/samsung-a35-5g",
},
          
{
  title: "Samsung S24 Ultra 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s24-ultra-5g-sm-s928-stylus.jpg?v=1706266704",
  landingPage: "https://cforcover.com/collections/samsung-s24-ultra",
},
{
  title: "Samsung S24 Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s24-plus-5g-sm-s926.jpg?v=1706266704",
  landingPage: "https://cforcover.com/collections/samsung-s24-plus",
},
{
  title: "Samsung S24 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s24-5g-sm-s921.jpg?v=1706266704",
  landingPage: "https://cforcover.com/collections/samsung-s24",
},
{
  title: "Samsung S23 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s23-plus-5g.jpg?v=1706767532",
  landingPage: "https://cforcover.com/collections/samsung-s23-plus",
},
{
  title: "Samsung S23 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_S23_5G.png?v=1694417428",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-s23-5g",
},
{
  title: "Samsung M52 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m32-5g_1b782912-e3f2-4c57-abc0-81381396c0a0.jpg?v=1705038645",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-m52-5g",
},
{
  title: "Samsung M15 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/M15.jpg?v=1713432598",
  landingPage: "https://cforcover.com/collections/samsung-m15-5g",
},
{
  title: "Samsung M34",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m34-5g.jpg?v=1694606322",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m34",
},
{
  title: "Samsung M33 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m33_78967a45-3342-41a2-989a-96bfc03cae2f.jpg?v=1704346190",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-m33-5g",
},
{
  title: "Samsung M30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m30.jpg?v=1705041194",
  landingPage: "https://cforcover.com/collections/samsung-m30",
},
{
  title: "Samsung M20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m20-m205f.jpg?v=1708151527",
  landingPage: "https://cforcover.com/collections/samsung-m20",
},
{
  title: "Samsung A31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a31.jpg?v=1704346189",
  landingPage: "https://cforcover.com/collections/samsung-a31",
},
{
  title: "Samsung Z Flip 4",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Z_Flip_4.png?v=1694417428",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-z-flip-4",
},
{
  title: "Samsung Z Flip 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-z-flip5-5g.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-z-flip5",
},
{
  title: "Samsung Z Fold 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-z-fold5-5g.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-z-fold-5",
},
  {
      "title": "Samsung S22 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s22-5g.jpg?v=1706266704",
      "landingPage": "https://cforcover.com/collections/samsung-s22-5g"
  },
{
  title: "Samsung A02",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a02s-sm-a025-new_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a02",
},
{
  title: "Samsung A02s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a02s-sm-a025-new_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a02s",
},
{
  title: "Samsung A03",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a03_c058c093-3ddd-45cd-8f1d-f341d62c22c6.jpg?v=1687427935",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a03",
},
{
  title: "Samsung A03 Core",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a03-core_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a03-core",
},
{
  title: "Samsung A03s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a03s_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a03s",
},
{
  title: "Samsung A04",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a04_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a04",
},
{
  title: "Samsung A04 Core",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a04-core_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a04-core",
},
{
  title: "Samsung A04E",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a04e_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a04e",
},
{
  title: "Samsung A04s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a04s_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a04s",
},
{
  title: "Samsung A10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a10s.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-a10",
},
{
  title: "Samsung A10s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a10s.jpg?v=1694410973",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a10s",
},
{
  title: "Samsung A12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a12-sm-a125_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a12",
},
{
  title: "Samsung A11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a12-sm-a125_d8e56926-6cfc-49de-be80-9904b2f32594.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-a11",
},
{
  title: "Samsung A13 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a13_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a13-4g",
},
{
  title: "Samsung A13 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a13-5g_575d3cc7-06df-41c4-9d6d-8777a8fe9f26.jpg?v=1687428034",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a13-5g",
},
{
  title: "Samsung A14 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a14-4g_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a14-4g",
},
{
  title: "Samsung A14 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a14-5g_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a14-5g",
},
{
  title: "Samsung A20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a20_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a20",
},
{
  title: "Samsung A20s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a20s-sm-a207_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxya20s",
},
{
  title: "Samsung A21s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a21s.jpg?v=1694410973",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a21s",
},
{
  title: "Samsung A22 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a22_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a22-4g",
},
{
  title: "Samsung A22 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A22_5G.jpg?v=1713430581",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a22-5g",
},
{
  title: "Samsung A23 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a23_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a23-4g",
},
{
  title: "Samsung A23 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a23-5g_60x60.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a23-5g",
},
{
  title: "Samsung A30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a30_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a30",
},
{
  title: "Samsung A30s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a30.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a30s",
},
{
  title: "Samsung A32 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a32-4g-new.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a32-4g",
},
{
  title: "Samsung A32 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a32-4g-new_60x60.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a32-5g",
},
{
  title: "Samsung A33 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a33-5g_60x60.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a33-5g",
},
{
  title: "Samsung A34 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a34_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a34-5g",
},
{
  title: "Samsung A50",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a50-sm-a505f-ds_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a50",
},
{
  title: "Samsung A50s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a50s.jpg?v=1694410973",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a50s",
},
{
  title: "Samsung A51",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a51-sm-a515.jpg?v=1699431757",
  landingPage: "https://cforcover.com/collections/samsung-a51",
},
{
  title: "Samsung A52",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a52.jpg?v=1694410973",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a52",
},
{
  title: "Samsung A52s 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a52s-5g_60x60.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a52s-5g",
},
{
  title: "Samsung A53 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a53-5g_427f8b8c-5abb-4da9-af60-bcabe7178ecb.jpg?v=1687428099",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a53-5g",
},
{
  title: "Samsung A54 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a54_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a54-5g",
},
{
  title: "Samsung A70",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a70s.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-a70",
},
{
  title: "Samsung A70s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a70s.jpg?v=1694410973",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a70s",
},
{
  title: "Samsung A71",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_A71.jpg?v=1713430602",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-a71",
},
{
  title: "Samsung A72 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a72-4g-r1_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a72-5g",
},
{
  title: "Samsung A73 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a73-5g.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-a73-5g",
},
{
  title: "Samsung F02",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a02s-sm-a025-new_60x60.jpg?v=1687418412",
  landingPage: "https://cforcover.com/collections/samsung-f02",
},
{
  title: "Samsung F02s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a02s-sm-a025-new_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-f02s",
},
{
  title: "Samsung F04",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_F04.jpg?v=1694410972",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-f04",
},
{
  title: "Samsung F12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f12_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-f12",
},
{
  title: "Samsung F13 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f13.jpg?v=1694410973",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-f13",
},
{
  title: "Samsung F14 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_F14_5G.jpg?v=1694410971",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-f14-5g",
},
{
  title: "Samsung F23 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m23_3f87831b-e4d6-41ba-ace4-40126b6139c5.jpg?v=1687428461",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-f23-5g",
},
{
  title: "Samsung F34",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_F34_5G.jpg?v=1713430622",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-f34",
},
{
  title: "Samsung F42 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f42-5g-1_60x60.jpg?v=1687418413",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-f42-5g",
},
{
  title: "Samsung F54 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f54-5g_1d14672a-47b1-48bf-a547-b9c1f856d07f.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-f54-5g",
},
{
  title: "Samsung J5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j5.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-j5",
},
{
  title: "Samsung J6 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j6-plus.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-j6-plus",
},
{
  title: "Samsung J7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-j700f-1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-j7",
},
{
  title: "Samsung J7 (2015)",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-j700f-1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-j7",
},
{
  title: "Samsung J7 2015",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-2015.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-j7-2015",
},
{
  title: "Samsung J7 Nxt",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-nxt-sm-j701fds.jpg?v=1694599147",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-j7-nxt",
},
{
  title: "Samsung J7 Prime",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-prime_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-j7-prime",
},
{
  title: "Samsung J7 Prime 2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m01.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-j7-prime-2",
},
{
  title: "Samsung J8 2018",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j8-2018.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-j8-2018",
},
{
  title: "Samsung M01s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m01.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-m01s",
},
{
  title: "Samsung M02",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m02s.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m02",
},
{
  title: "Samsung M02s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m02s_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m02s",
},
{
  title: "Samsung M04",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m04.jpg?v=1694602926",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m04",
},
{
  title: "Samsung M10s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m10s-m107f_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m10s",
},
{
  title: "Samsung M11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m11-sm-m115.jpg?v=1694603193",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m11",
},
{
  title: "Samsung M12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m12_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m12",
},
{
  title: "Samsung M13 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m13-india-1_1c7bf767-ee9e-46e9-bf7d-5e7baabd7a57.jpg?v=1687428535",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m13-4g",
},
{
  title: "Samsung M13 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m13-5g-1.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m13-5g",
},
{
  title: "Samsung M14 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m14-5g-sm-m146.jpg?v=1687418413",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m14",
},
{
  title: "Samsung M21",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m21-2021.jpg?v=1694606171",
  landingPage: "https://cforcover.com/collections/samsung-m21",
},

{
  title: "Samsung M23 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m23_2a37eff8-3731-4b49-b50d-32ed4dad23a5.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-m23-5g",
},
{
  title: "Samsung M30s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m30s.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m30s",
},
{
  title: "Samsung M31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m31s.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m31",
},
{
  title: "Samsung M31s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m31s_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m31s",
},
{
  title: "Samsung M32",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m32-5g.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m32",
},
{
  title: "Samsung M32 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m32_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m32-5g",
},
{
  title: "Samsung M34",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m34-5g.jpg?v=1694606322",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m34",
},
{
  title: "Samsung M51",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m51.jpg?v=1694606936",
  landingPage: "https://coverpe.myshopify.com/collections/samsung-galaxy-m51",
},
{
  title: "Samsung M53 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m53-5g_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-m53-5g",
},
{
  title: "Samsung M54 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m54-5g.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samsung-m54-5g",
},
{
  title: "Samsung On Nxt",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j7-nxt-sm-j701fds.jpg?v=1694599147",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-on-nxt",
},
{
  title: "Samsung On5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-j5_56e10f56-f499-4a13-af17-9c955566af74.jpg?v=1699431695",
  landingPage: "https://cforcover.com/collections/samsung-on5",
},
{
  title: "Samsung S20 FE 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s20-fe-5g_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-s20-fe-5g",
},
{
  title: "Samsung S21 FE 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s21-fe-5g_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-s21-fe-5g",
},
{
  title: "Samsung S23 FE 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s23.jpg?v=1699431644",
  landingPage: "https://cforcover.com/collections/samsung-s23-fe-5g",
},
{
  title: "Samsung S23 Ultra",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_S23_Ultra.png?v=1694417428",
  landingPage:
    "https://coverpe.myshopify.com/collections/samsung-galaxy-s23-ultra",
},
{
  title: "Samung A03",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a5.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/samung-a03",
},
{
  title: "Samsung A05",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a05.jpg?v=1702368445",
  landingPage: "https://cforcover.com/collections/samsung-a05",
},
{
  title: "Samsung A05s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a05s.jpg?v=1702368446",
  landingPage: "https://cforcover.com/collections/samsung-a05s",
},
{
  title: "Samsung Note 10 Lite",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/sasmung-galaxy-note10-lite-r.jpg?v=1702530425",
  landingPage: "https://cforcover.com/collections/samsung-note-10-lite",
},
{
  title: "Samsung F62",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-f62_72466dd9-3b49-42bc-98e2-58826a0e613a.jpg?v=1702624482",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-f62",
},
{
  title: "Samsung J6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_J6.jpg?v=1713430643",
  landingPage: "https://cforcover.com/collections/samsung-j6",
},
{
  title: "Samsung M62",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-m62.jpg?v=1702624482",
  landingPage: "https://cforcover.com/collections/samsung-m62",
},
{
  title: "Samsung Note 10 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-note10-plus.jpg?v=1702712193",
  landingPage: "https://cforcover.com/collections/samsung-note-10-pro",
},
{
  title: "Samsung S9 plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s9-plus.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-s9-plus",
},
{
  title: "Samsung S8 plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-s8-plus.jpg?v=1694410973",
  landingPage: "https://cforcover.com/collections/samsung-galaxy-s8-plus",
},
{
  title: "Samsung S22 Ultra",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_S22_Ultra.jpg?v=1713430662",
  landingPage: "https://cforcover.com/collections/samsung-s22-ultra-5g",
},
{
  title: "Samsung A15 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a15-5g-new.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/samsung-a15-5g",
},
{
  title: "Samsung A25 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-a25.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/samsung-a25-5g",
},
{
  title: "Samsung A55 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/a55.jpg?v=1713432584",
  landingPage: "https://cforcover.com/collections/samsung-a55-5g",
},
{
  title: "Samsung F15 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/F15.jpg?v=1713432595",
  landingPage: "https://cforcover.com/collections/samsung-f15-5g",
},
 {
                  "title": "Samsung Tab 4",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-4",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_60bb98fe-4417-4db8-99d6-03dea38afc91.jpg?v=1710910679"
                },
                {
                  "title": "Samsung Tab A SM-T350 8",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a-sm-t350-8",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_15609596-c8fa-4681-9de4-3821c4b749ea.jpg?v=1710910743"
                },
                {
                  "title": "Samsung Tab A SM-T515 10.1",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a-sm-t515-10-1",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_289cfc74-1562-40d0-be51-768250282bd6.jpg?v=1710910803"
                },
                {
                  "title": "Samsung Tab A SM-T580 10.1",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a-sm-t580-10-1",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_ea7d7a61-b266-480c-a987-8a03b527dff4.jpg?v=1710910880"
                },
                {
                  "title": "Samsung Tab A T385",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a-t385",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_9c0bdc90-7ff9-4b19-9a53-3ffff9ddae8f.jpg?v=1710911943"
                },
            
                {
                  "title": "Samsung Tab A7 Lite T225",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a7-lite-t225",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_7a43de43-92d6-4c24-a381-26c14f0e26d9.jpg?v=1710910947"
                },
             
                {
                  "title": "Samsung Tab A8 SM-X200 10.5\"",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a8-sm-x200-10-5",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_370e7227-0904-435d-a159-37ac2caebd4c.jpg?v=1710911003"
                },
                {
                  "title": "Samsung Tab A9",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-a9",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_88590ad1-9c43-4b75-a730-52408e4d2593.jpg?v=1710911061"
                },
                {
                  "title": "Samsung Tab E SM-T560",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-e-sm-t560",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b5fa7204-5a56-4bba-9797-a255f4a50753.jpg?v=1710911125"
                },
                {
                  "title": "Samsung Tab S2 SM-T815",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s2-sm-t815",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b480e51f-9371-468b-8199-b56b43caf39a.jpg?v=1710911179"
                },
                {
                  "title": "Samsung Tab S3 SM-T825",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s3-sm-t825",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_05e7304d-a366-4017-8021-e1a1109cdffc.jpg?v=1710911232"
                },
                {
                  "title": "Samsung Tab S5e SM-T725",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s5e-sm-t725",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_dd90adec-a34c-4fe0-bba2-93a6f23b53e1.jpg?v=1710911282"
                },
                {
                  "title": "Samsung Tab S6 Lite SM-P610",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s6-lite-sm-p610",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_f95b9237-e9e5-4119-94b1-9cb675070cfd.jpg?v=1710911417"
                },
                {
                  "title": "Samsung Tab S6 SM-T860",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s6-sm-t860",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_48f5371c-6d11-45bd-96be-35cfe5ccd0aa.jpg?v=1710911348"
                },
                {
                  "title": "Samsung Tab S7",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s7",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b6ed64fa-fb8b-4e33-b24e-405f46b3083d.jpg?v=1710910555"
                },
                {
                  "title": "Samsung Tab S7 FE",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s7-fe",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_502318ad-63d4-4093-b488-a7ead3e40e95.jpg?v=1710910491"
                },
                {
                  "title": "Samsung Tab S7 Plus",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s7-plus",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b18fc732-2b28-4f4d-a61c-44eb09c4d20e.jpg?v=1710911484"
                },
                {
                  "title": "Samsung Tab S8 11\"",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s8-11",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_5ba2f41d-9cb6-44fa-91de-4d66dc765286.jpg?v=1710911559"
                },
                {
                  "title": "Samsung Tab S8 Ultra",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s8-ultra",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_aef3235b-088e-4ab9-8561-82d6fd6a91e5.jpg?v=1710911664"
                },
                {
                  "title": "Samsung Tab S8 Plus 12.4\"",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s8-plus-12-4",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_c776d446-85b1-4ebe-b8c0-456e24686ee0.jpg?v=1710911611"
                },
                {
                  "title": "Samsung Tab S9 FE 10.9\"",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s9-fe-10-9",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_67b7e385-b44c-4405-a2f6-e692cd84ede4.jpg?v=1710911736"
                },
                {
                  "title": "Samsung Tab S9 SM-X710",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s9-sm-x710",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_d90e15ef-d60e-4dca-958b-f212d2dc6a05.jpg?v=1710911797"
                },
                {
                  "title": "Samsung Tab S9 Ultra",
                  "landingPage": "https://cforcover.com/collections/samsung-tab-s9-ultra",
                  "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_8890e58f-c165-483f-98d1-118755ba3a10.jpg?v=1710911875"
                },

   {
        "title": "Samsung Tab A 8",
        "landingPage": "https://cforcover.com/collections/samsung-tab-a-8-inch",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_A_SM-T295.jpg?v=1730953444"
    },
    {
        "title": "Samsung Tab A T280 / T285",
        "landingPage": "https://cforcover.com/collections/samsung-tab-a-t280-t285",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_A_T280.jpg?v=1730954145"
    },
    {
        "title": "Samsung Tab A 10.5\"",
        "landingPage": "https://cforcover.com/collections/samsung-tab-a-10-5-inch",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_A_T595.jpg?v=1730952308"
    },
    {
        "title": "Samsung Tab A7",
        "landingPage": "https://cforcover.com/collections/samsung-tab-a7",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_A7_SM-T500.jpg?v=1730952085"
    },
    {
        "title": "Samsung Tab A9 Plus 11\"",
        "landingPage": "https://cforcover.com/collections/samsung-tab-a9-plus-11",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_A9_Plus.jpg?v=1730953954"
    },
    {
        "title": "Samsung Tab S8 Ultra",
        "landingPage": "https://cforcover.com/collections/samsung-tab-s8-ultra",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_S8_Ultra_SM-X900.jpg?v=1730953821"
    },
    {
        "title": "Samsung Tab S9 Plus 12\"",
        "landingPage": "https://cforcover.com/collections/samsung-tab-s9-plus",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Tab_S9_Plus.jpg?v=1730953704"
    },
];

const xiaomi = [
  {
    "title": "Redmi 15A 5G",
    "landingPage": "https://cforcover.com/collections/redmi-15a-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-15a.jpg?v=1776510937"
  },
  {
    "title": "Redmi Note 15 5G",
    "landingPage": "https://cforcover.com/collections/redmi-note-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-15-global.jpg?v=1770880637"
  },
  {
    "title": "Redmi Note 15 Pro 5G",
    "landingPage": "https://cforcover.com/collections/redmi-note-15-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-15-pro-global.jpg?v=1769150666"
  },
  {
    "title": "Redmi Note 15 Pro Plus 5G",
    "landingPage": "https://cforcover.com/collections/redmi-note-15-pro-plus-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-15-pro-plus-global.jpg?v=1769150667"
  },
  {
    "title": "Redmi 15C 5G",
    "landingPage": "https://cforcover.com/collections/redmi-15c-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-15c.jpg?v=1761901334"
  },
   {
    "title": "Redmi 15 5G",
    "landingPage": "https://cforcover.com/collections/redmi-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-15-5g.jpg?v=1758265961"
  },
        {
          "title": "Redmi Note 14 SE 5G",
          "landingPage": "https://cforcover.com/collections/redmi-note-14-se-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Note_14_se.avif?v=1753703522"
        },
  {
    "title": "Xiaomi 15 5G",
    "landingPage": "https://cforcover.com/collections/xiaomi-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-15.jpg?v=1747908304"
  },
  {
    "title": "Xiaomi 15 Ultra 5G",
    "landingPage": "https://cforcover.com/collections/xiaomi-15-ultra-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-15-ultra.jpg?v=1747908308"
  },
  {
    "title": "Redmi A5 4G",
    "landingPage": "https://cforcover.com/collections/redmi-a5-4g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a5-4g.jpg?v=1746695915"
  },
     {
        "title": "Redmi 14C 5G",
        "landingPage": "https://cforcover.com/collections/redmi-14c-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_14C_5G.jpg?v=1733226173"
    },
    {
        "title": "Redmi Note 14 Pro Plus 5G",
        "landingPage": "https://cforcover.com/collections/redmi-note-14-pro-plus-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Note_14_Pro_Plus_5G.jpg?v=1733226679"
    },
    {
        "title": "Redmi Note 14 5G",
        "landingPage": "https://cforcover.com/collections/redmi-note-14-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Note_14_5G.jpg?v=1733226679"
    },
    {
        "title": "Redmi Note 14 Pro 5G",
        "landingPage": "https://cforcover.com/collections/redmi-note-14-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Note_14_Pro_5G.jpg?v=1733226679"
    },
     {
        "title": "Redmi A4 5G",
        "landingPage": "https://cforcover.com/collections/redmi-a4-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_A4_5G.jpg?v=1732519503"
    },
    {
        "title": "Xiaomi Mi 10i",
        "landingPage": "https://cforcover.com/collections/xiaomi-mi-10i",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Mi_10i.jpg?v=1728298772"
    },
  {
      "title": "Xiaomi 11X",
      "landingPage": "https://cforcover.com/collections/xiaomi-mi-11x",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_11X_6cae29aa-69db-4776-9101-35ef1afbbaeb.jpg?v=1722516094"
  },
  {
      "title": "Xiaomi 14 5G",
      "landingPage": "https://cforcover.com/collections/xiaomi-14-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_14_5G.jpg?v=1727768620"
  },
  {
      "title": "Xiaomi 14 Ultra 5G",
      "landingPage": "https://cforcover.com/collections/xiaomi-14-ultra-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_14_Ultra_5G.jpg?v=1727768817"
  },
  {
      title: "Redmi 13 5G",
      imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-13-5g.jpg?v=1721994903",
      landingPage: "https://cforcover.com/collections/redmi-13-5g",
  },
  {
       title: "Xiaomi 14 CIVI 5G",
       imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/14-civi-mzb0hd0in-xiaomi-original-imahfqjyhhumkm6n.webp?v=1722058757",
       landingPage: "https://cforcover.com/collections/xiaomi-14-civi-5g",
  },
{
  title: "Redmi K20 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k20pro.jpg?v=1695118142",
  landingPage: "https://cforcover.com/collections/redmi-k20-pro",
},
{
  title: "Redmi K20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_K20.jpg?v=1713524801",
  landingPage: "https://cforcover.com/collections/xiaomi-redmi-k20",
},
{
  title: "Redmi Note 13 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-13-pro.jpg?v=1703932617",
  landingPage: "https://cforcover.com/collections/redmi-note-13-pro-5g",
},
{
  title: "Redmi Note 13 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-13.jpg?v=1703932617",
  landingPage: "https://cforcover.com/collections/redmi-note-13-5g",
},
{
  title: "Redmi A3 2024",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a3.jpg?v=1708929131",
  landingPage: "https://cforcover.com/collections/redmi-a3-2024",
},
{
  title: "Xiaomi 14 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_9ece076f-a861-40b2-a8bc-7b6901528643.jpg?v=1712217092",
  landingPage: "https://cforcover.com/collections/xiaomi-14-5g",
},
{
  title: "Xiaomi 14 Ultra 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_72729930-6de5-4ff9-bc1f-9d21d8cc50db.jpg?v=1712217144",
  landingPage: "https://cforcover.com/collections/xiaomi-14-ultra-5g",
},
{
  title: "Redmi Note 12 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-12-pro.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-12-pro-5g",
},
{
  title: "Redmi Note 12 Pro Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-12-pro-plus.jpg?v=1695118142",
  landingPage: "https://cforcover.com/collections/redmi-note-12-pro-plus",
},
{
  title: "Redmi Note 12 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-12-pro-plus.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-12-pro-plus-5g",
},
{
  title: "Redmi K50i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k50i-5g_af9c4941-69fd-47aa-9c72-cd12201fb200.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-k50i",
},
{
  title: "Redmi K50i 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k50i-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-k50i-5g",
},
{
  title: "Redmi A1 2022",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a2_d9c02c5f-3718-4393-ac94-20b2967064b4.jpg?v=1687426795",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-a1-2022",
},
{
  title: "Redmi A2 2023",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a2-_1.jpg?v=1687427781",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-a2-2023",
},
{
  title: "Redmi A2 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a2-plus.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-a2-plus",
},
{
  title: "Redmi A3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-mi-a3_eb13810f-ed03-4938-9cd5-6cbc4e722668.jpg?v=1699451539",
  landingPage: "https://cforcover.com/collections/redmi-a3",
},

{
  title: "Redmi 10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_10.jpg?v=1713430519",
  landingPage: "https://cforcover.com/collections/redmi-10",
},

{
  title: "Redmi 10C",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_10C.jpg?v=1713430538",
  landingPage: "https://cforcover.com/collections/redmi-10c",
},
{
  title: "Redmi 10 Power",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-10-power.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-10-power",
},
{
  title: "Redmi 10 Prime",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-10_07fd9cca-d222-4df0-877e-f42798522acb.jpg?v=1687426671",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-10-prime",
},
{
  title: "Redmi 10A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_10A.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-10a",
},
{
  title: "Redmi 11 Prime 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_11_Prime_4G.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-11-prime-4g",
},
{
  title: "Redmi 11 Prime 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-10-5g_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-11-prime-5g",
},
{
  title: "Redmi 12 4g",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-12.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-12-4g",
},
{
  title: "Redmi 12 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-12-5g.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-12-5g",
},
{
  title: "Redmi 12C",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-12c_fef3f830-a949-4e3a-b06f-18c7bac98997.jpg?v=1687427670",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-12c",
},
{
  title: "Redmi 4A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-4a.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-4a",
},
{
  title: "Redmi 5A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-5a_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-5a",
},
{
  title: "Redmi 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-mi-max.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-6",
},
{
  title: "Redmi 6A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-6a_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-6a",
},
{
  title: "Redmi 7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-7.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-7",
},
{
  title: "Redmi 7A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-7a-mzb8008in_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-7a",
},
{
  title: "Redmi 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-8_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-8",
},
{
  title: "Redmi 8A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-8a_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-8a",
},
{
  title: "Redmi 9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_9.jpg?v=1713430558",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-9",
},
{
  title: "Redmi 9 Activ",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-9-activ.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-9-activ",
},
{
  title: "Redmi 9 Power",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-9-power_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-9-power",
},
{
  title: "Redmi 9 Prime",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-9_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-9-prime",
},
{
  title: "Redmi 9A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-9a-1_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-9a",
},
{
  title: "Redmi 9C",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/redmi-9c.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-9c",
},
{
  title: "Redmi 9i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_9i.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-9i",
},
{
  title: "Redmi 9T",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-9t.jpg?v=1699432081",
  landingPage: "https://cforcover.com/collections/redmi-9t",
},

{
  title: "Redmi A1 Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-a1-plus-new_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-a1-plus",
},
{
  title: "Redmi K30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k30.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/redmi-k30",
},
{
  title: "Redmi K40",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k40.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/redmi-k40",
},
{
  title: "Redmi K40 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k40-pro.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/redmi-k40-pro",
},
{
  title: "Redmi K40 Pro Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-k40-pro-plus.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/redmi-k40-pro-plus",
},
{
  title: "Redmi Note 10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_10.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-10",
},
{
  title: "Redmi Note 10 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note10_28e457cc-c28e-4a0a-bfda-9bd9f8517764.jpg?v=1687426881",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-10-5g",
},
{
  title: "Redmi Note 10 Lite",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-10-lite.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-10-lite",
},
{
  title: "Redmi Note 10 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_10_Pro.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-10-pro",
},
{
  title: "Redmi Note 10 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note10-pro_e1998e8d-5118-4da1-9803-87e8c3b20794.jpg?v=1687426943",
  landingPage:
    "https://coverpe.myshopify.com/collections/redmi-note-10-pro-max",
},
{
  title: "Redmi Note 10S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_10S.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-10s",
},
{
  title: "Redmi Note 10T 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note10--_1.jpg?v=1687427003",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-10t-5g",
},
{
  title: "Redmi Note 11 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-11-global_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-11-4g",
},
{
  title: "Redmi Note 11 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-11-pro-global_83532f2c-09d1-4710-9e28-bc2c856ce6f6.jpg?v=1687427107",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-11-pro",
},
{
  title: "Redmi Note 11 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-11-pro-global_83532f2c-09d1-4710-9e28-bc2c856ce6f6.jpg?v=1687427107",
  landingPage:
    "https://coverpe.myshopify.com/collections/redmi-note-11-pro-5g",
},
{
  title: "Redmi Note 11 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_11_Pro_Plus_5G.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-11-pro-plus-5g",
},
{
  title: "Redmi Note 11 SE",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_11_SE.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-11-se",
},
{
  title: "Redmi Note 11S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_11S.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-11s",
},
{
  title: "Redmi Note 11T 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-11t-5g.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-11t-5g-1",
},
{
  title: "Redmi Note 12 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_12.jpg?v=1695118142",
  landingPage: "https://cforcover.com/collections/redmi-note-12-4g",
},
{
  title: "Redmi Note 12 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-12-pro.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-12-pro-4g",
},
{
  title: "Redmi Note 4",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-4-sn_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-4",
},
{
  title: "Redmi Note 4X",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-4x.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/redmi-note-4x",
},
{
  title: "Redmi Note 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-5.jpg?v=1699431987",
  landingPage: "https://cforcover.com/collections/redmi-note-5",
},
{
  title: "Redmi Note 5 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-5-pro_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-5-pro",
},
{
  title: "Redmi Note 6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-6-pro-r_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-6-pro",
},
{
  title: "Redmi Note 7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-7.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-7",
},
{
  title: "Redmi Note 7 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-7-pro_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-7-pro",
},
{
  title: "Redmi Note 7S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_7S.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-7s",
},
{
  title: "Redmi Note 8",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-8-1_60x60.jpg?v=1687418424",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-8",
},
{
  title: "Redmi Note 8 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-8-pro_44a9952d-495b-414a-8839-3d52ef54e272.jpg?v=1687427192",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-8-pro",
},
{
  title: "Redmi Note 9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_9.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-9",
},
{
  title: "Redmi Note 9 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-9-pro-global_7ee540ba-3c8a-40bb-9d91-9935d3432443.jpg?v=1687427250",
  landingPage: "https://coverpe.myshopify.com/collections/redmi-note-9-4g",
},
{
  title: "Redmi Note 9 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Note_9_Pro.jpg?v=1695118142",
  landingPage:
    "https://coverpe.myshopify.com/collections/xiaomi-redmi-note-9-pro",
},
{
  title: "Redmi Note 9 Pro 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-9-pro-global_7ee540ba-3c8a-40bb-9d91-9935d3432443.jpg?v=1687427250",
  landingPage:
    "https://coverpe.myshopify.com/collections/redmi-note-9-pro-4g",
},
{
  title: "Redmi Note 9 Pro Max",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-9-pro-max.jpg?v=1699431815",
  landingPage: "https://cforcover.com/collections/redmi-note-9-pro-max",
},
{
  title: "Redmi Note 9S",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-9s.jpg?v=1699431883",
  landingPage: "https://cforcover.com/collections/redmi-note-9s",
},
{
  title: "Redmi S2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_S2.jpg?v=1699431936",
  landingPage: "https://cforcover.com/collections/redmi-s2",
},
{
  title: "Redmi Y2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Redmi_Y2.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-y2",
},
{
  title: "Redmi Y3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-y3.jpg?v=1695118142",
  landingPage: "https://coverpe.myshopify.com/collections/xiaomi-redmi-y3",
},
{
  title: "Redmi 13C 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-13c-4g.jpg?v=1702368446",
  landingPage: "https://cforcover.com/collections/redmi-13c-4g",
},
{
  title: "Redmi 13C 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-13c-5g.jpg?v=1702368446",
  landingPage: "https://cforcover.com/collections/redmi-13c-5g",
},
{
  title: "Redmi 11i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-11i.jpg?v=1702530426",
  landingPage: "https://cforcover.com/collections/redmi-11i",
},
{
  title: "Redmi Note 13 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/xiaomi-redmi-note-13-pro-plus.jpg?v=1702981506",
  landingPage: "https://cforcover.com/collections/redmi-note-13-pro-plus-5g",
},
 {
      "title": "Xiaomi Pad 6 (11)",
      "landingPage": "https://cforcover.com/collections/xiaomi-pad-6-11",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_b6831511-eb39-4b55-9bfc-df176d3df64f.jpg?v=1710912089"
    },
    {
      "title": "Xiaomi Redmi Pad 10.6",
      "landingPage": "https://cforcover.com/collections/xiaomi-redmi-pad-10-6",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_acc16c9b-7edf-45d9-8716-d39a38e26b9b.jpg?v=1710912672"
    }
];

const Huawei =[
  {
    "title": "Huawei nova 13 5G",
    "landingPage": "https://cforcover.com/collections/huawei-nova-13-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/huavei-nova-13.jpg?v=1768291536"
  },
  {
    "title": "Huawei nova 13 Pro 5G",
    "landingPage": "https://cforcover.com/collections/huawei-nova-13-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/huavei-nova-13-pro.jpg?v=1768291537"
  },
{
      "title": "Huawei MatePad T8",
      "landingPage": "https://cforcover.com/collections/huawei-matepad-t8",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_697491f0-ee12-4eb3-bd6c-e2edf231c114.jpg?v=1710851863"
  },
  {
      "title": "Huawei MediaPad M5 Lite",
      "landingPage": "https://cforcover.com/collections/huawei-mediapad-m5-lite",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_4a414411-d4de-4cef-b626-22fe653d4218.jpg?v=1710851936"
  },
  {
      "title": "Huawei MediaPad T5 10.1",
      "landingPage": "https://cforcover.com/collections/huawei-mediapad-t5-10-1",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_7fb69eca-df61-4901-a606-d3867bc3e209.jpg?v=1710852088"
  },
];

const Lenovo = [
  {
        "title": "Tab E7 Tablet (TB-7104F)",
        "landingPage": "https://cforcover.com/collections/tab-e7-tablet-tb-7104f",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Tab_E7_Tablet_TB-7104F.jpg?v=1730952554"
  },
  {
      "title": "Lenovo M10 5G",
      "landingPage": "https://cforcover.com/collections/lenovo-m10-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_c0444e8f-448d-413b-bb7c-70a645a4021a.jpg?v=1710852154"
  },
  {
      "title": "Lenovo M10 Plus X606",
      "landingPage": "https://cforcover.com/collections/lenovo-m10-plus-x606",
      "imagePath": ""
  },
  {
      "title": "Lenovo Tab 4 8 TB-8504X",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-4-8-tb-8504x",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_0438f873-fb8f-4bc8-a497-0ec1f2e1e586.jpg?v=1710852349"
  },
  {
      "title": "Lenovo Tab K10 FHD",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-k10-fhd",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_73b50250-017a-4755-8be0-289eee1c450f.jpg?v=1710909399"
  },
  {
      "title": "Lenovo Tab M10 X505X",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-m10-x505x",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_fa094734-39c2-463e-9738-68bc38f9ff22.jpg?v=1710909668"
  },
  {
      "title": "Lenovo Tab M10 X605",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-m10-x605",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_17073de1-3be5-4fc6-ba8a-741955e8ddfd.jpg?v=1710909745"
  },
  {
      "title": "Lenovo Tab M7",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-m7",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_feb5efce-0387-4c67-a0bc-2ccd0b69c98d.jpg?v=1710909479"
  },
  {
      "title": "Lenovo Tab M8",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-m8",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_23b69c81-4c4c-4b70-a578-526f2cc24a7d.jpg?v=1710909541"
  },
  {
      "title": "Lenovo Tab M9",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-m9",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_4ea01303-f30a-4626-aaec-1671a6720f8c.jpg?v=1710909603"
  },
  {
      "title": "Lenovo Tab P11",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-p11",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_20d9f904-10e8-434d-a58a-d07b958a4496.jpg?v=1710909816"
  },
  {
      "title": "Lenovo Tab P11 Plus",
      "landingPage": "https://cforcover.com/collections/lenovo-tab-p11-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_6ba1a4d5-ff54-4f2c-ada1-16dd3f6817b7.jpg?v=1710909335"
  },
];

const realme = [
  {
    "title": "Realme 16 5G",
    "landingPage": "https://cforcover.com/collections/realme-16-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-16.jpg?v=1776510893"
  },
  {
    "title": "Realme P4 Power 5G",
    "landingPage": "https://cforcover.com/collections/realme-p4-power-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p4-power.jpg?v=1772196464"
  },
  {
    "title": "Realme P3 Lite 5G",
    "landingPage": "https://cforcover.com/collections/realme-p3-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c75-5g_96bbf158-ac91-4f1e-b61b-8238c282e559.jpg?v=1772086951"
  },
  {
    "title": "Realme 15 Lite 5G",
    "landingPage": "https://cforcover.com/collections/realme-15-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-15-lite-5g.jpg?v=1772086951"
  },
  {
    "title": "Realme C83 5G",
    "landingPage": "https://cforcover.com/collections/realme-c83-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/173508-v1-realme-c83-5g-mobile-phone-hres-1.avif?v=1772086951"
  },
  {
    "title": "Realme C71 4G",
    "landingPage": "https://cforcover.com/collections/realme-c71-4g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c75-5g_52d5c18a-f51e-424a-93ef-dd02cbb8f61e.jpg?v=1771047984"
  },
  {
    "title": "Realme GT 8 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-gt-8-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt8-pro-cn.jpg?v=1766208596"
  },
  {
    "title": "Realme 16 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-16-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-16-pro.jpg?v=1770879813"
  },
  {
    "title": "Realme 16 Pro Plus 5G",
    "landingPage": "https://cforcover.com/collections/realme-16-pro-plus-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-16-pro-plus.jpg?v=1769763616"
  },
  {
    "title": "Realme C85 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-c85-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c85-pro.jpg?v=1769839623"
  },
  {
    "title": "Realme Narzo 90 5G",
    "landingPage": "https://cforcover.com/collections/realme-narzo-90-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-90.jpg?v=1768977122"
  },
  {
    "title": "Realme Narzo 90x 5G",
    "landingPage": "https://cforcover.com/collections/realme-narzo-90x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-90x.jpg?v=1768977121"
  },
  {
    "title": "Realme P4x 5G",
    "landingPage": "https://cforcover.com/collections/realme-p4x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p4x.jpg?v=1768291536"
  },
  {
    "title": "Realme C85 5G",
    "landingPage": "https://cforcover.com/collections/realme-c85-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c85.jpg?v=1767157990"
  },
  {
    "title": "Realme Neo 7x 5G",
    "landingPage": "https://cforcover.com/collections/realme-neo-7x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-neo7x.jpg?v=1764333772"
  },
   {
    "title": "Realme 15x 5G",
    "landingPage": "https://cforcover.com/collections/realme-15x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-15x.jpg?v=1767002987"
  },
  {
    "title": "Realme GT 8 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-gt-8-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt8-pro-cn.jpg?v=1766208596"
  },
  {
    "title": "Realme GT 7T 5G",
    "landingPage": "https://cforcover.com/collections/realme-gt-7t-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt-7t.jpg?v=1761299455"
  },
  {
    "title": "Realme 15 5G",
    "landingPage": "https://cforcover.com/collections/realme-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-15.jpg?v=1759129617"
  },
  {
    "title": "Realme 15T 5G",
    "landingPage": "https://cforcover.com/collections/realme-15t-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-15t-5g.jpg?v=1758265943"
  },
  {
    "title": "Realme P4 5G",
    "landingPage": "https://cforcover.com/collections/realme-p4-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p4.jpg?v=1758265951"
  },
  {
    "title": "Realme P4 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-p4-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p4-pro.jpg?v=1758265958"
  },
    {
    "title": "Realme Narzo 70 5G",
    "landingPage": "https://cforcover.com/collections/realme-narzo-70-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-70.jpg?v=1753194512"
  },
    {
    "title": "Realme C61",
    "landingPage": "https://cforcover.com/collections/realme-c61",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c61_7488746c-9dc4-4cf4-bb12-5df607f09972.jpg?v=1753194512"
  },
    {
    "title": "Realme 14 Pro Lite 5G",
    "landingPage": "https://cforcover.com/collections/realme-14-pro-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-13-pro.jpg?v=1753194512"
  },
    {
    "title": "Realme GT 7 5G",
    "landingPage": "https://cforcover.com/collections/realme-gt-7-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt-7.jpg?v=1753194512"
  },
          {
          "title": "Realme 15 Pro 5G",
          "landingPage": "https://cforcover.com/collections/realme-15-pro-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-15-pro.jpg?v=1753703522"
        },
  {
    title: "Realme C75 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c75-5g.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/realme-c75-5g"
  },
  {
    title: "Realme Narzo 80 Pro 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-80-pro-5g.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/realme-narzo-80-pro-5g"
  },
  {
    title: "Realme Narzo 80x 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-80x-5g.jpg?v=1751290066",
    landingPage: "https://cforcover.com/collections/realme-narzo-80x-5g"
  },
  {
    "title": "Realme 14 5G",
    "landingPage": "https://cforcover.com/collections/realme-14-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-14-5g.jpg?v=1746695915"
  },
  {
    "title": "Realme 14T 5G",
    "landingPage": "https://cforcover.com/collections/realme-14t-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-14t.jpg?v=1746695916"
  },
  {
    "title": "Realme GT 5G",
    "landingPage": "https://cforcover.com/collections/realme-gt-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt-5g.jpg?v=1695361566"
  },
  {
    "title": "Realme GT 3",
    "landingPage": "https://cforcover.com/collections/realme-gt-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-gt-neo5.jpg?v=1742808698"
  },
  {
    "title": "Realme Narzo N65 5G",
    "landingPage": "https://cforcover.com/collections/realme-narzo-n65-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Narzo_N65_5G.jpg?v=1745056377"
  },
  {
    "title": "Realme P3 5G",
    "landingPage": "https://cforcover.com/collections/realme-p3-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p3-5g.jpg?v=1742638323"
  },
   {
    "title": "Realme P3 Pro 5G",
    "landingPage": "https://cforcover.com/collections/realme-p3-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p3-pro-5g.jpg?v=1742638306"
  },
  {
    "title": "Realme P3 Ultra 5G",
    "landingPage": "https://cforcover.com/collections/realme-p3-ultra-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p3-ultra-5g.jpg?v=1742638319"
  },
  {
    "title": "Realme P3x 5G",
    "landingPage": "https://cforcover.com/collections/realme-p3x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_P3x_5G.jpg?v=1742357276"
  },
{
      "title": "Realme P3 5G",
      "landingPage": "https://cforcover.com/collections/realme-p3-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-p3-5g.jpg?v=1742638323"
    },
     {
        "title": "Realme 14 Pro 5G",
        "landingPage": "https://cforcover.com/collections/realme-14-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-14pro.jpg?v=1741433289"
     },
     {
        "title": "Realme 13 5G",
        "landingPage": "https://cforcover.com/collections/realme-13-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_13_5G.jpg?v=1734946896"
    },
    {
        "title": "Realme 14X 5G",
        "landingPage": "https://cforcover.com/collections/realme-14x-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_14X_5G.jpg?v=1737959858"
    },
    {
        "title": "Realme GT 6 5G",
        "landingPage": "https://cforcover.com/collections/realme-gt-6-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_6_5G.jpg?v=1737959851"
    },
      {
        "title": "Realme 14 Pro Plus 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-14pro-plus.jpg?v=1737703167",
        "landingPage": "https://cforcover.com/collections/realme-14-pro-plus-5g"
     },
      {
        "title": "Realme Narzo 70x 5G",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Narzo_70X_184d648a-c7d1-4703-9040-b9ad45d72f29.jpg?v=1736331416",
        "landingPage": "https://cforcover.com/collections/realme-narzo-70x-5g"
     },
     {
        "title": "Realme GT 7 Pro 5G",
        "landingPage": "https://cforcover.com/collections/realme-gt-7-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_7_Pro_5G.jpg?v=1734440930"
    },
    {
        "title": "Realme P2 Pro 5G",
        "landingPage": "https://cforcover.com/collections/realme-p2-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_P2_Pro_5G.jpg?v=1729831320"
    },
    {
        "title": "Realme Narzo 70 Turbo 5G",
        "landingPage": "https://cforcover.com/collections/realme-narzo-70-turbo-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Narzo_70_Turbo_5G.jpg?v=1729831320"
    },
    {
        "title": "Realme C63 5G",
        "landingPage": "https://cforcover.com/collections/realme-c63-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_C63_5G.jpg?v=1730456908"
    },
      {
        "title": "Realme 13 Pro 5G",
        "landingPage": "https://cforcover.com/collections/realme-13-pro-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_13_Pro_5G_dc0e43b6-5e42-4766-93f5-4db7fb6cac19.jpg?v=1728298772"
      },
      {
        "title": "Realme GT 2",
        "landingPage": "https://cforcover.com/collections/realme-gt-2",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_2.jpg?v=1728298772"
      },
    {
      "title": "Realme 13 Plus 5G",
      "landingPage": "https://cforcover.com/collections/realme-13-plus-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_13_Plus_5G.jpg?v=1727765218"
    },
   {
      "title": "Realme 13 Pro Plus 5G",
      "landingPage": "https://cforcover.com/collections/realme-13-pro-plus-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_13_Pro_Plus_5G.jpg?v=1727765218"
   },
   {
      "title": "Realme Narzo N63",
      "landingPage": "https://cforcover.com/collections/realme-narzo-n63",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Narzo_N63.jpg?v=1727766792"
   },
    {
      "title": "Realme 12x 5G",
      "landingPage": "https://cforcover.com/collections/realme-12x-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_12x_5G.jpg?v=1725455550"
    },
    {
      "title": "Realme GT 2 Pro",
      "landingPage": "https://cforcover.com/collections/realme-gt-2-pro-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_2_Pro.jpg?v=1725455557"
    },
    {
       title: "Realme 13 Pro Plus 5G",
       imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_13_Pro_Plus.webp?v=1721995282",
       landingPage: "https://cforcover.com/collections/realme-13-pro-plus-5g",
   },
  {
      title: "Realme C61",
      imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c61.webp?v=1721729155",
      landingPage: "https://cforcover.com/collections/realme-c61",
  },
  {
        title: "Realme GT 6T 5G",
        imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_6T.jpg?v=1717568460",
        landingPage: "https://cforcover.com/collections/realme-gt-6t-5g",
  },
  {
        title: "Realme X7 Max 5G",
        imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-x7-max-5g.jpg?v=1707802501",
        landingPage: "https://cforcover.com/collections/realme-x7-max-5g",
 },  
 {
      "title": "Realme P1 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_P1_5G.jpg?v=1714135363",
      "landingPage": "https://cforcover.com/collections/realme-p1-5g"
  },
  {
      "title": "Realme P1 Pro 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_P1_Pro_5G.jpg?v=1714135363",
      "landingPage": "https://cforcover.com/collections/realme-p1-pro-5g"
   },
   {
      "title": "Realme C65 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_C65_5G.jpg?v=1714194864",
      "landingPage": "https://cforcover.com/collections/realme-c65-5g"
  },
 
 {
   title: "Realme 12 Pro Plus 5G",
   imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-12-pro-plus.jpg?v=1708151527",
   landingPage: "https://cforcover.com/collections/realme-12-pro-plus",
 },
{
  title: "Realme 12 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_12_5G.jpg?v=1713430439",
  landingPage: "https://cforcover.com/collections/realme-12-5g",
},
{
  title: "Realme 12 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-12-pro.jpg?v=1709030066",
  landingPage: "https://cforcover.com/collections/realme-12-pro-5g",
},
{
  title: "Realme 12 Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_e57b153a-d5b4-49a6-bd6f-2050364c2b3d.jpg?v=1712216801",
  landingPage: "https://cforcover.com/collections/realme-12-plus-5g",
},
{
  title: "Realme Narzo 70 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_2942c975-01e0-45d6-b42f-70aaed162a4d.jpg?v=1712216885",
  landingPage: "https://cforcover.com/collections/realme-narzo-70-pro-5g",
},
{
  title: "Realme 11 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-11-pro_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-11-pro-5g",
},
{
  title: "Realme 11 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-11-pro-plus_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-11-pro-plus-5g",
},
{
  title: "Realme C33",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c33_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c33",
},
{
  title: "Realme C35",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c35_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c35",
},
{
  title: "Realme C55",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c55_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c55",
},
{
  title: "Realme GT Neo 2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_GT_Neo_2.jpg?v=1713430495",
  landingPage: "https://cforcover.com/collections/realme-gt-neo-2-5g",
},
{
  title: "Realme GT Neo 3T 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-neo-3-gt.jpg?v=1694410948",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-gt-neo-3t-5g",
},
{
  title: "Realme 10 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-10-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-10-4g",
},
{
  title: "Realme 10 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-10-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-10-5g",
},

{
  title: "Realme 10 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-10-pro-plus.jpg?v=1695361566",
  landingPage: "https://coverpe.myshopify.com/collections/realme-10-pro-5g",
},
{
  title: "Realme 10 Pro Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme_10_Pro_Plus_5G.jpg?v=1695361566",
  landingPage: "https://coverpe.myshopify.com/collections/realme-10-pro-plus",
},
{
  title: "Realme 10 Pro Plus 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme_10_Pro_Plus_5G.jpg?v=1695361566",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-10-pro-plus-5g",
},
{
  title: "Realme 11 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_11_5G.jpg?v=1713430421",
  landingPage: "https://coverpe.myshopify.com/collections/realme-11",
},
{
  title: "Realme 2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-realme-2-pro.jpg?v=1687418411",
  landingPage: "https://cforcover.com/collections/realme-2",
},
{
  title: "Realme 2 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oppo-realme-2-pro_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-2-pro",
},
{
  title: "Realme 3",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-3_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-3",
},
{
  title: "Realme 3 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-3pro_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-3-pro",
},
{
  title: "Realme 3i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-3i.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/realme-3i",
},
{
  title: "Realme 5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-5_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-5",
},
{
  title: "Realme 5i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-5i_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-5i",
},
{
  title: "Realme 5s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-5s_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-5s",
},
{
  title: "Realme 6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-6_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-6",
},
{
  title: "Realme 6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-6-pro.jpg?v=1699429581",
  landingPage: "https://coverpe.myshopify.com/collections/realme-6-pro",
},
{
  title: "Realme 7 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-7.jpg?v=1699432342",
  landingPage: "https://coverpe.myshopify.com/collections/realme-7-4g",
},
{
  title: "Realme 7 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-7-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-7-5g",
},
{
  title: "Realme 7 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-7-pro.jpg?v=1699432343",
  landingPage: "https://cforcover.com/collections/realme-7-pro",
},
{
  title: "Realme 7i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-7i.jpg?v=1699429582",
  landingPage: "https://cforcover.com/collections/realme-7i",
},
{
  title: "Realme 8 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-8_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-8-4g",
},
{
  title: "Realme 8 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-8-5g_b977fc51-d7aa-4475-b747-f36d9f95b456.jpg?v=1687426526",
  landingPage: "https://coverpe.myshopify.com/collections/realme-8-5g",
},
{
  title: "Realme 8 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-8-pro-ofic_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-8-pro",
},
{
  title: "Realme 8i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-8i_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-8i",
},
{
  title: "Realme 8S 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-8s-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-8s-5g",
},
{
  title: "Realme 9",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9",
},
{
  title: "Realme 9 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9-4g_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9-4g",
},
{
  title: "Realme 9 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9-5g",
},
{
  title: "Realme 9 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9-pro_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9-pro-5g",
},
{
  title: "Realme 9 Pro Plus",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9-pro-plus_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9-pro-plus",
},
{
  title: "Realme 9i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9i-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9i",
},
{
  title: "Realme 9i 4G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9i-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9i-4g",
},
{
  title: "Realme 9i 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-9i-5g-r_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-9i-5g",
},
{
  title: "Realme C1",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_C1.jpg?v=1713430465",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c1",
},
{
  title: "Realme C11",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c11_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c11",
},
{
  title: "Realme C11 2021",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c11-2021_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c11-2022",
},
{
  title: "Realme C12",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c12_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c12",
},
{
  title: "Realme C15",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c15-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c15",
},
{
  title: "Realme C17",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c15-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c17",
},
{
  title: "Realme C2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c2_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c2",
},
{
  title: "Realme C20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c20-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c20",
},
{
  title: "Realme C20A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c20-r1_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c20a",
},
{
  title: "Realme C21",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c21_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c21",
},
{
  title: "Realme C21Y",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c21y_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c21y",
},
{
  title: "Realme C25",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c25_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c25",
},
{
  title: "Realme C25s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c25s_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c25s",
},
{
  title: "Realme C25Y",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c25y_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c25y",
},
{
  title: "Realme C30",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c30_76e7df0c-7e12-4709-9555-4586d8aea365.jpg?v=1687426383",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c30",
},
{
  title: "Realme C30s",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c30s_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c30s",
},
{
  title: "Realme C31",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c31_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-c31",
},
{
  title: "Realme Narzo 60 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo60-pro.jpg?v=1695361566",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-narzo-60-pro-5g",
},
{
  title: "Realme Narzo N53",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-n53_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-n53",
},
{
  title: "Realme Narzo N55",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-n55_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-n55",
},
{
  title: "Realme Narzo 10",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-10_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-10",
},
{
  title: "Realme Narzo 20",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-20_60x60.jpg?v=1687418411",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-20",
},
{
  title: "Realme Narzo 20 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-20_60x60.jpg?v=1687418411",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-narzo-20-pro",
},
{
  title: "Realme Narzo 30 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-30-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-30-5g",
},
{
  title: "Realme Narzo 30A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-30a_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-30a",
},
{
  title: "Realme Narzo 50",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-50",
},
{
  title: "Realme Narzo 50 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50-pro-5g.jpg?v=1695361566",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-narzo-50-pro-5g",
},
{
  title: "Realme Narzo 50A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50a_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-50-5a",
},
{
  title: "Realme Narzo 50A Prime",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50a-prime_a7a36412-51f1-46eb-b6d7-141b7922ed25.jpg?v=1687426580",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-narzo-50a-prime",
},
{
  title: "Realme Narzo 50i",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50i_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-50i",
},
{
  title: "Realme Narzo 50i Prime",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-50i-prime_60x60.jpg?v=1687418412",
  landingPage:
    "https://coverpe.myshopify.com/collections/realme-narzo-50i-prime",
},
{
  title: "Realme Narzo 60 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo60-5g.jpg?v=1695361566",
  landingPage: "https://coverpe.myshopify.com/collections/realme-narzo-60-5g",
},
{
  title: "Realme U1",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-u1.jpg?v=1699432251",
  landingPage: "https://cforcover.com/collections/realme-u1",
},
{
  title: "Realme V13 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-v13-5g_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/realme-v13-5g",
},
{
  title: "Realme V25",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-v25.jpg?v=1699429582",
  landingPage: "https://coverpe.myshopify.com/collections/realme-v25",
},
{
  title: "Realme X",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-x.jpg?v=1699432161",
  landingPage: "https://coverpe.myshopify.com/collections/realme-x",
},
{
  title: "Realme X2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-x2-pro.jpg?v=1695363001",
  landingPage: "https://coverpe.myshopify.com/collections/realme-x2",
},
{
  title: "Realme XT",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-xt.jpg?v=1695361566",
  landingPage: "https://coverpe.myshopify.com/collections/realme-xt",
},
{
  title: "Realme C53",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c53.jpg?v=1702368446",
  landingPage: "https://cforcover.com/collections/realme-c53",
},
{
  title: "Realme C51",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c51.jpg?v=1702368446",
  landingPage: "https://cforcover.com/collections/realme-c51",
},
{
  title: "Realme 11x 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-11x-5g.jpg?v=1702875786",
  landingPage: "https://cforcover.com/collections/realme-11x-5g",
},
{
  title: "Realme Narzo 60x 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-60x-5g.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/realme-narzo-60x-5g",
},
{
  title: "Realme C67",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c67-5g.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/realme-c67",
},

{
  title: "Realme Narzo 60x 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-narzo-60x-5g.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/realme-narzo-60x-5g",
},
 {
      "title": "Realme Pad 10.4 inch\"",
      "landingPage": "https://cforcover.com/collections/realme-pad-10-4-inch",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_6cd1b21e-0dd4-4751-8fcf-89241c7146b5.jpg?v=1710910222"
  },
  {
      "title": "Realme Pad 2",
      "landingPage": "https://cforcover.com/collections/realme-pad-2",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_359eb46b-1faa-4920-a015-8a7fe03f6f26.jpg?v=1710910153"
  },
  {
      "title": "Realme Pad Mini",
      "landingPage": "https://cforcover.com/collections/realme-pad-mini",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_3a5521e1-6f40-4d99-a855-23298e78a5bf.jpg?v=1710910300"
  },
  {
      "title": "Realme Pad X",
      "landingPage": "https://cforcover.com/collections/realme-pad-x",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_a52b6e92-5212-4a2d-aca6-2ba233c3295f.jpg?v=1710910381"
  },
{
  title: "Realme C67",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/realme-c67-5g.jpg?v=1702875787",
  landingPage: "https://cforcover.com/collections/realme-c67",
},
];

const iqoo = [
  {
    "title": "iQOO 15R 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-15r-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-15r.jpg?v=1775732114"
  },
  {
    "title": "iQOO Z11x 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-z11x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z11x-5g.jpg?v=1777009677"
  },
  {
    "title": "iQOO 15 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-15-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-15.jpg?v=1766124864"
  },
  {
    "title": "iQOO Neo 11 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-neo-11-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-neo11-cn.jpg?v=1766208595"
  },
   {
    "title": "iQOO Z10 Lite 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-z10-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z10-lite.jpg?v=1755339319"
  },
    {
    "title": "iQOO Neo 10 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-neo-10-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-neo-10.jpg?v=1753194512"
  },
          {
          "title": "iQOO Z10R 5G",
          "landingPage": "https://cforcover.com/collections/iqoo-z10r-5g",
          "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z10r.jpg?v=1753703522"
        },
    {
    title: "iQOO Z10 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Z10_5G.jpg?v=1748954447",
    landingPage: "https://cforcover.com/collections/iqoo-z10-5g"
  },
  {
    "title": "iQOO Z10x 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-z10x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z10x.jpg?v=1746695915"
  },
  {
    "title": "iQOO Z10x 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-z10x-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Z10x_5G.jpg?v=1747483078"
  },
  {
    "title": "iQOO Z9 Turbo 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-z9-turbo-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z9-turbo-endurance.jpg?v=1746695916"
  },
  {
    "title": "iQOO 12 Pro 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-12-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_12_Pro_5G_e0b73e3f-c1dd-43fb-b7c2-d2ce6f2f2976.jpg?v=1745056326"
  },
  {
    "title": "iQOO 9 SE 5G",
    "landingPage": "https://cforcover.com/collections/iqoo-9-se",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_9_SE_5G.jpg?v=1745056346"
  },
    {
      "title": "iQOO Neo 10R 5G",
      "landingPage": "https://cforcover.com/collections/iqoo-neo-10r-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-neo-10r.jpg?v=1742637520"
    },
   {
        "title": "iQOO 13 5G",
        "landingPage": "https://cforcover.com/collections/iqoo-13-5g",
        "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_13_5G.jpg?v=1737959892"
    },
   {
      "title": "iQOO Z9s Pro 5G",
      "landingPage": "https://cforcover.com/collections/iqoo-z9s-pro-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Z9s_Pro_5G.jpg?v=1727765218"
   },
    {
      "title": "iQOO Z9s 5G",
      "landingPage": "https://cforcover.com/collections/iqoo-z9s-5g",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Z9s_5G.jpg?v=1727766176"
    },
    {
      "title": "iQOO Z9x 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iqoo_z9x.jpg?v=1717568460",
      "landingPage": "https://cforcover.com/collections/iqoo-z9x-5g"
    }, 
    {
      "title": "iQOO Neo 9 Pro",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Neo_9_Pro.jpg?v=1715258885",
      "landingPage": "https://cforcover.com/collections/iqoo-neo-9-pro-5g"
    },   
    {
      "title": "iQOO 12 5G",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_12_5G.jpg?v=1715258885",
      "landingPage": "https://cforcover.com/collections/iqoo-12-5g"
    },
{
  title: "iQOO Z9 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_088bfe2f-8c93-4999-9e2c-094c471758d4.jpg?v=1712216548",
  landingPage: "https://cforcover.com/collections/iqoo-z9-5g",
},
{
  title: "iQOO Z7 Pro 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO_Z7_Pro_5G.jpg?v=1714125703",
  landingPage: "https://cforcover.com/collections/iqoo-z7-pro-5g",
},
{
  title: "iQOO Z6 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6.jpg?v=1699426849",
  landingPage: "https://cforcover.com/collections/iqoo-z6-5g",
},
{
  title: "iQOO Z6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6-pro.jpg?v=1694410753",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-z6-pro",
},
{
  title: "iQOO Neo 7 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-neo7-se_60x60.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-neo-7-5g",
},
{
  title: "iQOO Neo 7 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iqoo-neo-7-pro-1.jpg?v=1694410754",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-neo-7-pro",
},
{
  title: "iQOO Neo 6 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iQOO-Neo-6-1.jpg?v=1694410754",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-neo-6-5g",
},
{
  title: "iQOO Neo 7",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-neo7-se.jpg?v=1687418412",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-neo-7",
},
{
  title: "iQOO Z3 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-qoo-z3.jpg?v=1699426849",
  landingPage: "https://cforcover.com/collections/iqoo-z3-5g",
},
{
  title: "iQOO Z5",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z5.jpg?v=1699426849",
  landingPage: "https://cforcover.com/collections/iqoo-z5",
},
{
  title: "iQOO Z6",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6.jpg?v=1699426849",
  landingPage: "https://cforcover.com/collections/iqoo-z6",
},
{
  title: "iQOO Z6 44W",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6-44w.jpg?v=1699426848",
  landingPage: "https://cforcover.com/collections/iqoo-z6-44w",
},
{
  title: "iQOO Z6 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6.jpg?v=1699426849",
  landingPage: "https://cforcover.com/collections/iqoo-z6-5g",
},
{
  title: "iQOO Z6 Pro",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6-pro.jpg?v=1694410753",
  landingPage: "https://coverpe.myshopify.com/collections/iqoo-z6-pro",
},
{
  title: "iQOO Z6 Lite",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/vivo-iqoo-z6-lite-5g.jpg?v=17023684463",
  landingPage: "https://cforcover.com/collections/iqoo-z6-lite",
},
];

const nothing = [
  {
    "title": "Nothing Phone 4A Pro 5G",
    "landingPage": "https://cforcover.com/collections/nothing-phone-4a-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone-4a-pro.jpg?v=1774690054"
  },
  {
    "title": "Nothing Phone 4A 5G",
    "landingPage": "https://cforcover.com/collections/nothing-phone-4a-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone-4a.jpg?v=1772086951"
  },
  {
    "title": "Nothing Phone 3A Lite 5G",
    "landingPage": "https://cforcover.com/collections/nothing-phone-3a-lite-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone-3a-lite.jpg?v=1768291535"
  },
    {
    "title": "Nothing Phone 3",
    "landingPage": "https://cforcover.com/collections/nothing-phone-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone3.jpg?v=1753194512"
  },
  {
    title: "CMF Nothing Phone 2 Pro",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-cmf-phone-2-pro.jpg?v=1750233817",
    landingPage: "https://cforcover.com/collections/cmf-nothing-phone-2-pro"
  },
  {
    "title": "Nothing Phone 3a",
    "landingPage": "https://cforcover.com/collections/nothing-phone-3a",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone-3a.jpg?v=1742637607"
  },
  {
    "title": "Nothing Phone 3a Pro",
    "landingPage": "https://cforcover.com/collections/nothing-phone-3a-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone-3a-pro.jpg?v=1742637604"
  },
  {
      "title": "Nothing Phone 2A Plus",
      "landingPage": "https://cforcover.com/collections/nothing-phone-2a-plus",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nothing_Phone_2A_Plus.jpg?v=1727766417"
  }, 
 {
      title: "CMF Nothing Phone 1",
      imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/308336_0_evfsit.webp?v=1721711946",
      landingPage: "https://cforcover.com/collections/cmf-phone-1"
  },
{
  title: "Nothing Phone 2A",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nothing_Phone_2A.jpg?v=1711436082",
  landingPage: "https://cforcover.com/collections/nothing-phone-2a",
},
{
  title: "Nothing Phone 2",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/nothing-phone2.jpg?v=1699275542",
  landingPage: "https://cforcover.com/collections/nothing-phone-2",
},
{
  title: "Nothing Phone 1",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nothing_Phone_1.jpg?v=1711436082",
  landingPage: "https://cforcover.com/collections/nothing-phone-1",
},
];

const honor = [
    {
    "title": "Honor 200 Pro 5G",
    "landingPage": "https://cforcover.com/collections/honor-200-pro-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/honor-200-pro.jpg?v=1753194512"
  },
    {
    "title": "Honor Magic 6 Pro",
    "landingPage": "https://cforcover.com/collections/honor-magic-6-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/honor-magic6-pro.jpg?v=1753194512"
  },
    {
    title: "Honor 200 5G",
    imagePath: "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Honor_200_5G.jpg?v=1748954446",
    landingPage: "https://cforcover.com/collections/honor-200-5g"
  },
  {
    "title": "Honor Magic 6 Pro",
    "landingPage": "https://cforcover.com/collections/honor-magic-6-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Honor_Magic_6_Pro.jpg?v=1747483077"
  },
  {
      "title": "Honor X9B",
      "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Honor_X9B.jpg?v=1714379963",
      "landingPage": "https://cforcover.com/collections/honor-x9b"
  },
{
  title: "Honor X8B",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/honor-x8b.jpg?v=1707802501",
  landingPage: "https://cforcover.com/collections/honor-x8b",
},
{
  title: "Honor X7B",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/honor-x7b-new.jpg?v=1707802500",
  landingPage: "https://cforcover.com/collections/honor-x7b",
},
{
  title: "Honor 9 Lite",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/huawei-honor-9-lite.jpg?v=1702096634",
  landingPage: "https://cforcover.com/collections/honor-9-lite",
},
{
  title: "Honor 90 5G",
  imagePath:
    "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/honor-90_91f8fc66-1f8e-4d4d-8a16-312793aaf7ed.jpg?v=1699436580",
  landingPage: "https://cforcover.com/collections/honor-90-5g",
},
 {
    "title": "Honor Pad 5(8)",
    "landingPage": "https://cforcover.com/collections/honor-pad-5-8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_23ce6fc6-10e3-4d17-9270-1fa4dcd80b2d.jpg?v=1710851681"
  },
  {
    "title": "Honor Pad 8",
    "landingPage": "https://cforcover.com/collections/honor-pad-8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/1_4235c25e-a033-46c9-8c12-44d7a78a2503.jpg?v=1710851738"
  },
  
];

const allBrands = [
...vivo, //vi
...google, //go, pi.
...poco, //po
...nokia, //no
...onePlus, //on
...itel, //it
...oppo, //op
...motorola, //mo
...tecno, //tec
...infinix, //in.

...realme, //rea
...apple, //ap, ip.
...samsung, //sa, ga
...iqoo, //iq

...xiaomi, //xi, red

...nothing,
...Lenovo,
...Huawei,
...honor,
...hmd,
];

// console.log(lava.length, vivo.length, google.length, poco.length, nokia.length, onePlus.length, itel.length, oppo.length, motorola.length, tecno.length, infinix.length, realme.length, apple.length, samsung.length, iqoo.length, xiaomi.length, asus.length);
// console.log(lava.length + vivo.length + google.length + poco.length + nokia.length + onePlus.length + itel.length + oppo.length + motorola.length + tecno.length + infinix.length + realme.length + apple.length + samsung.length + iqoo.length + xiaomi.length + asus.length);

const products = allBrands;

// variables
const globalSearch = document.querySelector("#global-search-input");
const errorMessaage = document.querySelector(".error-msg");
const displayGlobally = document.querySelector(".display-models-globally");

// function to display error message on screen
function dispalyErrorMessage(message) {
errorMessaage.textContent = message;
errorMessaage.style.color = "red";
errorMessaage.style.fontWeight = "bold";

setTimeout(() => {
  errorMessaage.textContent = "";
}, 1500);
}

// function to display drop-down search result
const displayPhones = (modelObject) => {
const docFrag = document.createDocumentFragment();
const anchor = document.createElement("a");
const div1 = document.createElement("div");
const div2 = document.createElement("div");
const image = document.createElement("img");
const para = document.createElement("p");

anchor.setAttribute("href", `${modelObject.landingPage}`);
anchor.setAttribute("target", "_blank");
anchor.setAttribute("style", "text-decoration: none");
div1.setAttribute("class", "one-item");
image.setAttribute("id", "product-image");
image.setAttribute("src", `${modelObject.imagePath}`);
image.setAttribute("alt", "");
image.setAttribute("width", "60px");
image.setAttribute("height", "75px");
para.setAttribute("id", "product-title");
para.textContent = `${modelObject.title}`;

div2.appendChild(image);
div1.appendChild(div2);
div1.appendChild(para);
anchor.appendChild(div1);

docFrag.appendChild(anchor);

displayGlobally.appendChild(docFrag);

// displayGlobally.innerHTML += `<a href= ${modelObject.landingPage} target="_blank" style="text-decoration: none;" class="one-item-wrapper">
//                                   <div class="one-item">
//                                               <div>
//                                                   <img id="product-image" src= ${modelObject.imagePath} alt="" width="60px" height="75px">
//                                               </div>
//                                                <p id="product-title">${modelObject.title}</p>
//                                   </div>
//                               </a>`;
};

// ************************************************************
// Function to handle clicks outside the search result box (displayGlobally)
function handleClickOutside(event) {
if (!displayGlobally.contains(event.target)) {
  // Clicked outside the search result box, so hide it
  displayGlobally.style.display = "none";
  globalSearch.value = "";
}
}
// ************************************************************

// function to search phone
function searchPhone() {
const searchValue = globalSearch.value;
const searchResult = products.filter((obj) => {
  if (obj.title.toLowerCase().includes(searchValue.toLowerCase())) return obj;
});

displayGlobally.innerHTML = "";
if (searchResult.length > 0) {
  searchResult.map((obj) => displayPhones(obj));

  displayGlobally.style.display = "block";
  displayGlobally.style.height = "40vh";
  displayGlobally.style.overflowY = "scroll";
} else {
  dispalyErrorMessage("No Models Available!!");
  displayGlobally.style.display = "none";
}

if (globalSearch.value == "") {
  displayGlobally.innerHTML = "";
  displayGlobally.style.display = "none";
}

// Attach the event listener to the document
document.addEventListener("click", handleClickOutside);
}

// default setting global search result
if (globalSearch.value == "") {
displayGlobally.innerHTML = "";
displayGlobally.style.display = "none";
}

// addEventListener
globalSearch.addEventListener("input", searchPhone);
// ------------------------------------------------------------------------
